var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _g2, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeature4200709F(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 129,
    viewBox: "0 0 98 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M63.0006 83.5952L63.0131 84.4671L30.4398 103.226L30.4336 102.354L63.0006 83.5952Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M30.4398 103.226L19.2533 96.8048L19.2408 95.9329L30.4336 102.354L30.4398 103.226Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M30.4336 102.353L19.2408 95.9323L51.8141 77.1736L63.0006 83.5946L30.4336 102.353Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M46.0024 77.8025L46.0211 86.3099L36.0269 92.0646L36.002 83.5634L46.0024 77.8025Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M36.0264 92.0659L31.2197 89.282L31.1947 80.7808L36.0014 83.5647L36.0264 92.0659Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M36.0014 83.5631L31.1947 80.7792L41.1951 75.0183L46.0019 77.8022L36.0014 83.5631Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M73.8302 1.44219C73.3059 1.13702 72.5755 1.18061 71.7702 1.64148L3.39638 41.0522C1.7983 41.974 0.506109 44.2036 0.512352 46.0346L0.66217 97.864C0.66217 98.7733 0.98678 99.4148 1.50491 99.7137L6.31161 102.498C5.79349 102.199 5.46888 101.557 5.46888 100.648L5.31906 48.8185C5.31281 46.9875 6.60501 44.7579 8.20308 43.8362L76.5832 4.43163C77.3885 3.97076 78.1126 3.92716 78.6432 4.23233L73.8302 1.44219Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M79.4539 58.03C79.4602 59.8548 78.1617 62.0906 76.5699 63.0124L8.3646 102.292C6.76653 103.214 5.4681 102.479 5.46185 100.648L5.44313 94.3641L5.31203 48.8188C5.30579 46.994 6.59798 44.7581 8.19606 43.8364L76.4014 4.55017C77.9994 3.62843 79.2979 4.36956 79.3041 6.20059L79.4352 52.0947L79.4539 58.03Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M79.4035 51.776C63.6724 60.6944 18.3333 86.4098 5.41139 94.0516L5.2803 48.5063C5.27405 46.6815 6.56625 44.4456 8.16432 43.5239L9.47524 42.764L75.0899 4.97257L76.3696 4.23767C77.9677 3.31593 79.2661 4.05706 79.2724 5.88809L79.4035 51.776Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M75.2047 50.6245C61.2528 58.6337 21.045 81.2351 9.59003 88.0921L9.47766 49.3291L75.0923 11.5376L75.2047 50.6245Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M17.4359 47.2928C17.7043 47.1371 17.9228 47.2616 17.9228 47.5668C17.9228 47.8719 17.7043 48.2455 17.4422 48.4012C17.1738 48.5569 16.9553 48.4323 16.9553 48.1272C16.9553 47.8221 17.1675 47.4484 17.4359 47.2928Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M18.6784 46.5757C18.9467 46.42 19.1652 46.5446 19.1652 46.8497C19.1652 47.1548 18.9467 47.5285 18.6846 47.6841C18.4162 47.8398 18.1978 47.7153 18.1978 47.4101C18.1978 47.105 18.41 46.7314 18.6784 46.5757Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M70.2668 18.3438L70.3667 51.1964L14.971 83.1024L14.8711 50.256L70.2668 18.3438Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M14.864 48.4304L70.2598 16.5244L70.266 18.343L14.8703 50.2552L14.864 48.4304ZM16.1999 49.1155C16.4683 48.9598 16.6806 48.5924 16.6806 48.281C16.6806 47.9758 16.4621 47.8512 16.1937 48.0069C15.9252 48.1626 15.7067 48.5363 15.7067 48.8415C15.713 49.1467 15.9315 49.2712 16.1999 49.1155ZM17.4422 48.3993C17.7106 48.2436 17.9228 47.8761 17.9228 47.5647C17.9228 47.2596 17.7043 47.135 17.4359 47.2907C17.1675 47.4464 16.9552 47.8201 16.9552 48.1253C16.9552 48.4304 17.1737 48.555 17.4422 48.3993ZM18.6782 47.6831C18.9466 47.5274 19.1588 47.1599 19.1588 46.8485C19.1588 46.5434 18.9404 46.4188 18.6719 46.5745C18.4035 46.7302 18.1913 47.1039 18.1913 47.409C18.1975 47.7142 18.4097 47.8388 18.6782 47.6831Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M16.2008 48.0076C16.4692 47.8519 16.6877 47.9765 16.6877 48.2816C16.6877 48.5867 16.4692 48.9604 16.2071 49.116C15.9387 49.2717 15.7202 49.1472 15.7202 48.842C15.714 48.5369 15.9324 48.1633 16.2008 48.0076Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M69.174 47.7838L69.692 47.4849L69.174 47.7838Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M69.6859 45.5485L69.6797 44.9507L69.6859 45.5485Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M69.6788 43.0136L69.6726 42.4158L69.6788 43.0136Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M69.1373 35.1033L69.6554 34.8044L69.1373 35.1033Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M42.9807 65.4095L43.4988 65.1106V65.7146V65.1106L42.9807 65.4095Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M46.0144 68.947C59.2547 65.7458 69.2177 61.1994 72.2828 53.8192L72.1767 17.2422C67.6134 24.23 58.5056 29.1127 45.9083 32.37L46.0144 68.947Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M47.3942 68.6794C59.9041 65.6588 69.3115 61.3615 72.208 54.3862L72.1082 19.8333C67.7946 26.4349 59.1925 31.0499 47.2943 34.1265L47.3942 68.6794Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M42.9563 55.2708L43.4744 54.9719L42.9563 55.2708Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M42.9301 47.6588L43.4481 47.3599L42.9301 47.6588Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M45.9071 32.3699C42.7984 39.0463 33.2786 43.8667 19.645 47.4977L19.7511 84.0747C32.9477 80.8361 43.4788 76.5201 46.0132 68.9469L45.9071 32.3699Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M46.096 32.1331L46.87 67.7759C44.7726 79.6464 21.9188 84.2178 21.9188 84.2178L21.1448 48.575C21.151 48.5687 42.9435 40.5969 46.096 32.1331Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M44.192 67.801C42.7375 74.384 31.0828 78.7934 24.5469 80.5435L24.5344 80.7988C31.0641 79.0488 42.7312 74.6394 44.1857 68.0564L44.192 67.801Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M44.1484 65.9014C42.5691 72.3972 30.9081 76.7754 24.5033 78.5317L24.4908 78.7871C30.9019 77.0308 42.5815 72.6463 44.1422 66.1567L44.1484 65.9014Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M44.1106 64.0007C42.4064 70.4093 30.7454 74.7565 24.4593 76.519L24.4468 76.7744C30.733 75.0056 42.4314 70.646 44.1043 64.2561L44.1106 64.0007Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M44.0668 62.0964C42.2377 68.4179 30.5768 72.7339 24.4154 74.5026L24.403 74.758C30.5705 72.983 42.2814 68.6483 44.0605 62.3518L44.0668 62.0964Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M44.0231 60.1968C42.0692 66.431 30.4082 70.7159 24.3717 72.4971L24.3593 72.7524C30.4082 70.965 42.1253 66.6552 44.0168 60.4584L44.0231 60.1968Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M43.9857 58.2979C41.907 64.4387 30.2398 68.6986 24.3282 70.486L24.3157 70.7414C30.2398 68.9477 41.9756 64.6629 43.9795 58.5594L43.9857 58.2979Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M43.9411 56.3926C41.7313 62.4462 30.0704 66.675 24.2836 68.4687L24.2773 68.724C30.0828 66.9241 41.8312 62.6579 43.9411 56.6542V56.3926Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M43.8981 54.4919C41.5634 60.4584 29.9024 64.656 24.2343 66.4559L24.228 66.7113C29.9149 64.8989 41.6757 60.6639 43.8981 54.7535V54.4919Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M43.8542 52.5913C41.3947 58.4705 29.7275 62.637 24.1904 64.4432L24.1842 64.6923C29.7463 62.8737 41.5258 58.6574 43.8542 52.8466V52.5913Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M43.817 50.6858C41.2326 56.4778 29.5655 60.6132 24.147 62.4318L24.1407 62.6809C29.5842 60.8499 41.3762 56.6647 43.8108 50.9411L43.817 50.6858Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M43.773 48.7871C41.0637 54.492 29.3965 58.5962 24.1029 60.421L24.0967 60.6701C29.4215 58.8329 41.226 54.6663 43.773 49.0425V48.7871Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M43.7304 46.8875C40.8963 52.4989 29.2229 56.5782 24.0541 58.4092L24.0479 58.6584C29.2478 56.8086 41.0711 52.6733 43.7241 47.1428L43.7304 46.8875Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M43.692 44.9819C40.7331 50.5062 29.0597 54.5544 24.0158 56.3916L24.0095 56.6407C29.0909 54.7848 40.9266 50.6681 43.6858 45.2373L43.692 44.9819Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M43.6474 43.0823C40.5636 48.5193 28.8902 52.5364 23.9649 54.3798L23.9586 54.629C28.9214 52.7606 40.7696 48.675 43.6411 43.3376L43.6474 43.0823Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M43.6055 41.177C40.3969 46.5268 28.7235 50.5128 23.923 52.3687L23.9167 52.6178C28.7547 50.7432 40.6216 46.6763 43.5993 41.4386L43.6055 41.177Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M43.5546 39.5389L43.5609 39.2773C40.2274 44.54 28.5477 48.4948 23.8721 50.357L23.8658 50.6061C28.5852 48.719 40.4646 44.677 43.5546 39.5389Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M44.2538 67.5283L46.2826 40.4366L46.1016 32.1284C45.3525 34.1401 43.5484 36.1206 41.2387 37.9765C35.9326 43.6191 29.8087 46.9261 29.8087 46.9261L30.5641 81.6721C34.1472 80.3456 38.1924 78.4585 41.3823 75.9299C43.4985 73.6754 44.903 70.8603 44.2538 67.5283Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M44.7663 36.9738C45.428 36.2078 46.0086 33.8723 46.096 32.1284L46.87 67.7712C47.1572 77.543 33.199 82.8118 33.199 82.8118L32.4249 47.169C32.4249 47.1753 39.6537 43.7499 44.7663 36.9738Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M35.1897 49.4974C37.2247 48.2954 44.4847 43.5372 46.0016 38.0628L45.9954 37.658C44.5222 43.1635 37.206 47.9528 35.1584 49.1611L35.1897 49.4974Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M35.2403 51.9252C37.2754 50.7232 44.6103 45.9588 46.046 40.2664L46.0398 39.8616C44.6415 45.5789 37.2566 50.3869 35.2091 51.5951L35.2403 51.9252Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M35.2893 54.3556C37.3243 53.1536 44.7279 48.3767 46.0888 42.4663L46.0825 42.0615C44.7529 47.9968 37.3056 52.8173 35.2581 54.0255L35.2893 54.3556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M35.3399 56.784C37.375 55.582 44.8535 50.7927 46.1269 44.6643L46.1207 44.2595C44.8659 50.4128 37.3562 55.2457 35.3087 56.4539L35.3399 56.784Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M35.3888 59.2181C37.4238 58.0161 44.9772 53.2143 46.1695 46.868L46.1633 46.4631C44.9834 52.8344 37.4051 57.6798 35.3575 58.888L35.3888 59.2181Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M35.4399 61.6494C37.4749 60.4474 45.097 55.6394 46.2144 49.0689L46.2082 48.6641C45.1033 55.2533 37.4562 60.1111 35.4087 61.3193L35.4399 61.6494Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M35.4897 64.0769C37.5247 62.8749 45.2217 58.0544 46.258 51.2659L46.2517 50.8611C45.2217 57.6683 37.5123 62.5386 35.4647 63.7406L35.4897 64.0769Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M35.5395 66.5053C37.5746 65.3033 45.3464 60.4704 46.2953 53.4639L46.2891 53.0591C45.3277 60.0843 37.5558 64.967 35.5083 66.169L35.5395 66.5053Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M35.5886 68.9347C37.6236 67.7327 45.4642 62.8936 46.3381 55.6629L46.3319 55.2581C45.4455 62.5012 37.6049 67.3902 35.5574 68.5984L35.5886 68.9347Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M35.6381 71.3698C37.6732 70.1678 45.5886 65.3162 46.3814 57.8675L46.3752 57.4626C45.5637 64.9238 37.6544 69.8252 35.6132 71.0335L35.6381 71.3698Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M35.6882 73.7992C37.7232 72.5972 45.7136 67.7331 46.419 60.0664L46.4128 59.6616C45.6762 67.3407 37.7045 72.2546 35.657 73.4629L35.6882 73.7992Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M35.7389 76.2266C37.7739 75.0246 45.8329 70.1543 46.4634 62.2635L46.4572 61.8586C45.7955 69.7557 37.7552 74.6821 35.7076 75.8903L35.7389 76.2266Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M35.7882 78.656C37.8232 77.454 45.9572 72.5713 46.5065 64.4624L46.5003 64.0576C45.9135 72.1727 37.8045 77.1115 35.757 78.3197L35.7882 78.656Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M75.9853 63.1799L75.205 27.5371C75.205 27.5371 59.3304 33.3603 46.1025 32.1271L46.8828 67.77C60.1107 69.0031 75.9853 63.1799 75.9853 63.1799Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M72.62 32.1521L72.6263 31.8594C67.9319 33.3105 58.5058 35.8142 49.3418 35.7892C49.192 35.7892 49.0359 35.7892 48.8861 35.7892L48.8799 35.9699C58.0563 36.2252 67.9132 33.6032 72.62 32.1521Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M72.6566 33.9705L72.6629 33.6777C67.9685 35.1289 58.5424 37.6325 49.3784 37.6076C49.2286 37.6076 49.0726 37.6076 48.9227 37.6076L48.9165 37.7882C58.0929 38.0436 67.9498 35.4216 72.6566 33.9705Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M72.695 35.7886L72.7012 35.4958C68.0069 36.947 58.5807 39.4506 49.4168 39.4257C49.267 39.4257 49.1109 39.4257 48.9611 39.4257L48.9548 39.6063C58.1375 39.8679 67.9944 37.2459 72.695 35.7886Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M72.7388 37.6079L72.7451 37.3152C68.0507 38.7663 58.6246 41.27 49.4606 41.2451C49.3108 41.2451 49.1547 41.2451 49.0049 41.2451L48.9987 41.4257C58.1751 41.6872 68.032 39.0653 72.7388 37.6079Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M72.7755 39.4326L72.7818 39.1399C68.0874 40.591 58.6613 43.0947 49.4973 43.0698C49.3475 43.0698 49.1915 43.0698 49.0416 43.0698L49.0354 43.2504C58.2118 43.5057 68.0687 40.8837 72.7755 39.4326Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M72.8124 41.251L72.8186 40.9583C68.1243 42.4094 58.6982 44.913 49.5342 44.8881C49.3844 44.8881 49.2283 44.8881 49.0785 44.8881L49.0723 45.0687C58.2549 45.3303 68.1118 42.7083 72.8124 41.251Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M72.8579 43.0691L72.8642 42.7764C68.1698 44.2275 58.7437 46.7311 49.5797 46.7062C49.4299 46.7062 49.2739 46.7062 49.124 46.7062L49.1178 46.8868C58.2942 47.1484 68.1511 44.5264 72.8579 43.0691Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M72.8948 44.894L72.9011 44.6013C68.2067 46.0524 58.7806 48.5561 49.6166 48.5312C49.4668 48.5312 49.3107 48.5312 49.1609 48.5312L49.1547 48.7118C58.3311 48.9671 68.1942 46.3452 72.8948 44.894Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M72.9384 46.7134L72.9446 46.4207C68.2503 47.8718 58.8241 50.3754 49.6602 50.3505C49.5104 50.3505 49.3543 50.3505 49.2045 50.3505L49.1982 50.5311C58.3747 50.7927 68.2316 48.1645 72.9384 46.7134Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M72.9754 48.5325L72.9816 48.2397C68.2873 49.6909 58.8611 52.1945 49.6972 52.1696C49.5474 52.1696 49.3913 52.1696 49.2415 52.1696L49.2352 52.3502C58.4117 52.6118 68.2685 49.9898 72.9754 48.5325Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M73.0135 50.3555L73.0197 50.0627C68.3254 51.5139 58.8992 54.0175 49.7353 53.9926C49.5854 53.9926 49.4294 53.9926 49.2796 53.9926L49.2733 54.1732C58.456 54.4286 68.3129 51.8066 73.0135 50.3555Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M73.0573 52.1755L73.0635 51.8828C68.3692 53.3339 58.943 55.8376 49.7791 55.8127C49.6293 55.8127 49.4732 55.8127 49.3234 55.8127L49.3171 55.9933C58.4936 56.2549 68.3505 53.6267 73.0573 52.1755Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M73.0941 53.9939L73.1004 53.7012C68.406 55.1523 58.9799 57.6559 49.8159 57.631C49.6661 57.631 49.5101 57.631 49.3602 57.631L49.354 57.8116C58.5304 58.0732 68.3873 55.4512 73.0941 53.9939Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M73.1309 55.8179L73.1371 55.5251C68.4428 56.9763 59.0166 59.4799 49.8527 59.455C49.7029 59.455 49.5468 59.455 49.397 59.455L49.3907 59.6356C58.5734 59.891 68.4303 57.269 73.1309 55.8179Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M73.1747 57.636L73.181 57.3433C68.4866 58.7944 59.0605 61.2981 49.8965 61.2731C49.7467 61.2731 49.5906 61.2731 49.4408 61.2731L49.4346 61.4537C58.611 61.7091 68.4679 59.0871 73.1747 57.636Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M73.213 59.4553L73.2193 59.1626C68.5249 60.6137 59.0988 63.1174 49.9348 63.0925C49.785 63.0925 49.629 63.0925 49.4791 63.0925L49.4729 63.2731C58.6493 63.5347 68.5062 60.9127 73.213 59.4553Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M73.25 61.2744L73.2563 60.9817C68.5619 62.4328 59.1358 64.9365 49.9718 64.9115C49.822 64.9115 49.666 64.9115 49.5161 64.9115L49.5099 65.0922C58.6926 65.3537 68.5494 62.7318 73.25 61.2744Z",
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.9996 82.3484L63.0121 83.2203L30.4389 101.979L30.4326 101.107L62.9996 82.3484Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.439 101.978L19.2525 95.557L19.24 94.6851L30.4328 101.106L30.439 101.978Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4327 101.107L19.24 94.686L51.8132 75.9272L62.9997 82.3483L30.4327 101.107Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0017 76.5583L46.0204 85.0658L36.0262 90.8205L36.0012 82.3192L46.0017 76.5583Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0264 90.8191L31.2197 88.0352L31.1947 79.5339L36.0014 82.3179L36.0264 90.8191Z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0009 82.3175L31.1942 79.5336L41.1947 73.7727L46.0014 76.5566L36.0009 82.3175Z",
    fill: "url(#paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8295 0.194873C73.3051 -0.110299 72.5748 -0.0667029 71.7695 0.394169L3.39564 39.8049C1.79757 40.7267 0.505377 42.9563 0.511619 44.7873L0.661437 96.6167C0.661437 97.526 0.986048 98.1674 1.50417 98.4664L6.31088 101.25C5.79275 100.951 5.46814 100.31 5.46814 99.4006L5.31832 47.5712C5.31208 45.7402 6.60428 43.5106 8.20235 42.5888L76.5824 3.18431C77.3877 2.72344 78.1118 2.67985 78.6425 2.98502L73.8295 0.194873Z",
    fill: "url(#paint6_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4537 56.7834C79.4599 58.6082 78.1615 60.844 76.5697 61.7658L8.36436 101.046C6.76629 101.967 5.46785 101.233 5.46161 99.4015L5.44288 93.1175L5.31179 47.5722C5.30555 45.7474 6.59774 43.5115 8.19581 42.5898L76.4011 3.30359C77.9992 2.38185 79.2976 3.12298 79.3039 4.95401L79.435 50.8481L79.4537 56.7834Z",
    fill: "url(#paint7_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4032 50.5313C63.6722 59.4498 18.3331 85.1652 5.41114 92.807L5.28005 47.2616C5.27381 45.4368 6.566 43.201 8.16408 42.2792L9.47499 41.5194L75.0897 3.72795L76.3694 2.99304C77.9675 2.0713 79.2659 2.81243 79.2721 4.64346L79.4032 50.5313Z",
    fill: "url(#paint8_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2042 49.3779C61.2523 57.3871 21.0445 79.9885 9.58954 86.8455L9.47717 48.0825L75.0918 10.291L75.2042 49.3779Z",
    fill: "url(#paint9_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4353 46.045C17.7037 45.8893 17.9222 46.0138 17.9222 46.319C17.9222 46.6241 17.7037 46.9977 17.4416 47.1534C17.1732 47.3091 16.9547 47.1845 16.9547 46.8794C16.9547 46.5743 17.1669 46.2006 17.4353 46.045Z",
    fill: "#FED488"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6777 45.3301C18.9461 45.1744 19.1646 45.299 19.1646 45.6041C19.1646 45.9092 18.9461 46.2829 18.684 46.4385C18.4156 46.5942 18.1971 46.4697 18.1971 46.1645C18.1971 45.8594 18.4094 45.4858 18.6777 45.3301Z",
    fill: "#FED488"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2662 17.0979L70.3661 49.9506L14.9704 81.8566L14.8705 49.0101L70.2662 17.0979Z",
    fill: "url(#paint10_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8638 47.186L70.2595 15.28L70.2658 17.0986L14.87 49.0108L14.8638 47.186ZM16.1997 47.8711C16.4681 47.7154 16.6803 47.348 16.6803 47.0366C16.6803 46.7314 16.4618 46.6068 16.1934 46.7625C15.925 46.9182 15.7065 47.2919 15.7065 47.5971C15.7127 47.9023 15.9312 48.0268 16.1997 47.8711ZM17.4419 47.1549C17.7103 46.9992 17.9226 46.6317 17.9226 46.3203C17.9226 46.0152 17.7041 45.8906 17.4357 46.0463C17.1672 46.202 16.955 46.5757 16.955 46.8809C16.955 47.186 17.1735 47.3106 17.4419 47.1549ZM18.6779 46.4387C18.9463 46.283 19.1586 45.9155 19.1586 45.6041C19.1586 45.299 18.9401 45.1744 18.6717 45.3301C18.4033 45.4858 18.191 45.8595 18.191 46.1646C18.1973 46.4698 18.4095 46.5944 18.6779 46.4387Z",
    fill: "url(#paint11_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2 46.762C16.4684 46.6063 16.6868 46.7309 16.6868 47.036C16.6868 47.3411 16.4684 47.7148 16.2062 47.8704C15.9378 48.0261 15.7194 47.9016 15.7194 47.5964C15.7131 47.2913 15.9316 46.9177 16.2 46.762Z",
    fill: "#FED488"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1716 46.5391L69.6897 46.2402L69.1716 46.5391Z",
    fill: "#FED488"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6834 44.3029L69.6771 43.7051L69.6834 44.3029Z",
    fill: "#FED488"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6781 41.7677L69.6719 41.1699L69.6781 41.7677Z",
    fill: "#FED488"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1348 33.8577L69.6528 33.5588L69.1348 33.8577Z",
    fill: "#FED488"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9781 64.1629L43.4962 63.864V64.4681V63.864L42.9781 64.1629Z",
    fill: "url(#paint12_linear)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0121 67.7014C59.2524 64.5002 69.2154 59.9538 72.2805 52.5736L72.1743 15.9966C67.6111 22.9844 58.5033 27.8671 45.906 31.1244L46.0121 67.7014Z",
    fill: "url(#paint13_linear)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3919 67.4338C59.9018 64.4132 69.3092 60.1159 72.2057 53.1406L72.1058 18.5876C67.7923 25.1893 59.1902 29.8043 47.292 32.8809L47.3919 67.4338Z",
    fill: "url(#paint14_linear)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9537 54.0252L43.4718 53.7263L42.9537 54.0252Z",
    fill: "url(#paint15_linear)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9292 46.4132L43.4472 46.1143L42.9292 46.4132Z",
    fill: "url(#paint16_linear)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9065 31.124C42.7978 37.8004 33.278 42.6209 19.6444 46.2518L19.7505 82.8288C32.9471 79.5903 43.4782 75.2743 46.0126 67.701L45.9065 31.124Z",
    fill: "url(#paint17_linear)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0938 30.8872L46.8678 66.53C44.7704 78.4006 21.9166 82.9719 21.9166 82.9719L21.1426 47.3291C21.1488 47.3229 42.9413 39.3511 46.0938 30.8872Z",
    fill: "url(#paint18_linear)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1891 66.5547C42.7346 73.1377 31.0799 77.5471 24.544 79.2971L24.5315 79.5525C31.0611 77.8024 42.7283 73.393 44.1828 66.81L44.1891 66.5547Z",
    fill: "#CCCCCC"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1455 64.655C42.5661 71.1508 30.9052 75.5291 24.5004 77.2854L24.4879 77.5407C30.8989 75.7845 42.5786 71.3999 44.1392 64.9104L44.1455 64.655Z",
    fill: "#CCCCCC"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1079 62.7554C42.4037 69.164 30.7428 73.5111 24.4566 75.2736L24.4441 75.529C30.7303 73.7602 42.4287 69.4006 44.1017 63.0107L44.1079 62.7554Z",
    fill: "#CCCCCC"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0641 60.8489C42.235 67.1703 30.5741 71.4863 24.4128 73.255L24.4003 73.5104C30.5678 71.7354 42.2787 67.4007 44.0578 61.1042L44.0641 60.8489Z",
    fill: "#CCCCCC"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0202 58.9502C42.0663 65.1844 30.4054 69.4693 24.3689 71.2505L24.3564 71.5058C30.4054 69.7184 42.1225 65.4086 44.014 59.2118L44.0202 58.9502Z",
    fill: "#CCCCCC"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9829 57.0505C41.9042 63.1913 30.237 67.4513 24.3254 69.2387L24.3129 69.4941C30.237 67.7004 41.9728 63.4155 43.9767 57.3121L43.9829 57.0505Z",
    fill: "#CCCCCC"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9378 55.1453C41.728 61.1989 30.0671 65.4277 24.2803 67.2213L24.274 67.4767C30.0796 65.6768 41.8279 61.4106 43.9378 55.4068V55.1453Z",
    fill: "#CCCCCC"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8954 53.2463C41.5607 59.2128 29.8998 63.4104 24.2316 65.2103L24.2253 65.4657C29.9122 63.6533 41.6731 59.4183 43.8954 53.5079V53.2463Z",
    fill: "#CCCCCC"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8516 51.3457C41.392 57.2249 29.7248 61.3915 24.1878 63.1976L24.1815 63.4467C29.7436 61.6281 41.5231 57.4118 43.8516 51.601V51.3457Z",
    fill: "#CCCCCC"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8142 49.4404C41.2298 55.2325 29.5627 59.3678 24.1442 61.1864L24.1379 61.4355C29.5814 59.6045 41.3734 55.4193 43.808 49.6958L43.8142 49.4404Z",
    fill: "#CCCCCC"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7702 47.5388C41.0609 53.2437 29.3937 57.3479 24.1001 59.1727L24.0939 59.4218C29.4187 57.5846 41.2232 53.418 43.7702 47.7942V47.5388Z",
    fill: "#CCCCCC"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7277 45.6411C40.8936 51.2525 29.2202 55.3319 24.0514 57.1629L24.0452 57.412C29.2452 55.5623 41.0684 51.4269 43.7215 45.8965L43.7277 45.6411Z",
    fill: "#CCCCCC"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6891 43.7336C40.7302 49.2579 29.0568 53.3061 24.0128 55.1433L24.0066 55.3925C29.088 53.5365 40.9237 49.4198 43.6829 43.989L43.6891 43.7336Z",
    fill: "#CCCCCC"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6445 41.8359C40.5607 47.273 28.8872 51.29 23.9619 53.1335L23.9557 53.3827C28.9185 51.5143 40.7667 47.4287 43.6382 42.0913L43.6445 41.8359Z",
    fill: "#CCCCCC"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6027 39.9307C40.3941 45.2805 28.7206 49.2664 23.9202 51.1224L23.9139 51.3715C28.7519 49.4969 40.6188 45.43 43.5965 40.1922L43.6027 39.9307Z",
    fill: "#CCCCCC"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5518 38.2928L43.5581 38.0312C40.2246 43.2939 28.5449 47.2487 23.8693 49.1108L23.863 49.36C28.5823 47.4729 40.4618 43.4309 43.5518 38.2928Z",
    fill: "#CCCCCC"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2516 66.2822L46.2804 39.1905L46.0994 30.8823C45.3503 32.894 43.5462 34.8745 41.2365 36.7304C35.9304 42.373 29.8065 45.68 29.8065 45.68L30.5619 80.426C34.145 79.0995 38.1902 77.2124 41.3801 74.6838C43.4963 72.4293 44.9008 69.6142 44.2516 66.2822Z",
    fill: "url(#paint19_linear)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M44.764 35.7277C45.4257 34.9617 46.0062 32.6262 46.0936 30.8823L46.8677 66.5251C47.1549 76.2969 33.1967 81.5657 33.1967 81.5657L32.4226 45.9229C32.4226 45.9292 39.6514 42.5038 44.764 35.7277Z",
    fill: "url(#paint20_linear)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1873 48.2525C37.2224 47.0505 44.4824 42.2923 45.9993 36.8179L45.9931 36.4131C44.5198 41.9186 37.2037 46.708 35.1561 47.9162L35.1873 48.2525Z",
    fill: "#CCCCCC"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2376 50.6835C37.2727 49.4815 44.6076 44.7171 46.0434 39.0247L46.0371 38.6199C44.6388 44.3372 37.254 49.1452 35.2064 50.3534L35.2376 50.6835Z",
    fill: "#CCCCCC"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2865 53.111C37.3215 51.909 44.7251 47.1321 46.0859 41.2217L46.0797 40.8169C44.7501 46.7522 37.3028 51.5726 35.2552 52.7809L35.2865 53.111Z",
    fill: "#CCCCCC"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3374 55.5394C37.3724 54.3374 44.8509 49.5481 46.1244 43.4197L46.1181 43.0149C44.8634 49.1682 37.3537 54.0011 35.3062 55.2093L35.3374 55.5394Z",
    fill: "#CCCCCC"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3861 57.9754C37.4211 56.7734 44.9745 51.9716 46.1668 45.6253L46.1606 45.2205C44.9808 51.5917 37.4024 56.4371 35.3549 57.6453L35.3861 57.9754Z",
    fill: "#CCCCCC"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M35.437 60.4028C37.472 59.2008 45.0941 54.3928 46.2115 47.8223L46.2052 47.4175C45.1003 54.0067 37.4533 58.8645 35.4058 60.0728L35.437 60.4028Z",
    fill: "#CCCCCC"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4869 62.8323C37.5219 61.6303 45.2189 56.8098 46.2552 50.0213L46.2489 49.6165C45.2189 56.4237 37.5094 61.2939 35.4619 62.496L35.4869 62.8323Z",
    fill: "#CCCCCC"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5367 65.2597C37.5718 64.0577 45.3436 59.2248 46.2925 52.2183L46.2862 51.8135C45.3249 58.8387 37.553 63.7214 35.5055 64.9234L35.5367 65.2597Z",
    fill: "#CCCCCC"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5857 67.6911C37.6207 66.4891 45.4613 61.6499 46.3352 54.4192L46.329 54.0144C45.4425 61.2576 37.602 66.1465 35.5544 67.3548L35.5857 67.6911Z",
    fill: "#CCCCCC"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6356 70.1251C37.6706 68.9231 45.5861 64.0715 46.3789 56.6228L46.3726 56.218C45.5611 63.6792 37.6519 68.5806 35.6106 69.7888L35.6356 70.1251Z",
    fill: "#CCCCCC"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6854 72.5545C37.7204 71.3525 45.7108 66.4885 46.4162 58.8218L46.41 58.417C45.6734 66.0961 37.7017 71.01 35.6542 72.2182L35.6854 72.5545Z",
    fill: "#CCCCCC"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7363 74.9839C37.7713 73.7819 45.8304 68.9117 46.4609 61.0208L46.4546 60.616C45.7929 68.5131 37.7526 73.4394 35.7051 74.6476L35.7363 74.9839Z",
    fill: "#CCCCCC"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7852 77.4134C37.8203 76.2114 45.9542 71.3286 46.5036 63.2198L46.4973 62.8149C45.9105 70.93 37.8016 75.8688 35.754 77.0771L35.7852 77.4134Z",
    fill: "#CCCCCC"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9832 61.9341L75.2029 26.2913C75.2029 26.2913 59.3283 32.1144 46.1005 30.8813L46.8808 66.5241C60.1086 67.7573 75.9832 61.9341 75.9832 61.9341Z",
    fill: "url(#paint21_linear)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6177 30.9062L72.6239 30.6135C67.9296 32.0647 58.5035 34.5683 49.3395 34.5434C49.1897 34.5434 49.0336 34.5434 48.8838 34.5434L48.8776 34.724C58.054 34.9794 67.9109 32.3574 72.6177 30.9062Z",
    fill: "#CCCCCC"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6544 32.7251L72.6607 32.4324C67.9663 33.8835 58.5402 36.3872 49.3762 36.3622C49.2264 36.3622 49.0704 36.3622 48.9205 36.3622L48.9143 36.5428C58.0907 36.7982 67.9476 34.1762 72.6544 32.7251Z",
    fill: "#CCCCCC"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6934 34.5442L72.6996 34.2515C68.0053 35.7026 58.5791 38.2062 49.4152 38.1813C49.2654 38.1813 49.1093 38.1813 48.9595 38.1813L48.9532 38.3619C58.1359 38.6235 67.9928 36.0015 72.6934 34.5442Z",
    fill: "#CCCCCC"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7369 36.3625L72.7431 36.0698C68.0487 37.5209 58.6226 40.0246 49.4586 39.9997C49.3088 39.9997 49.1528 39.9997 49.0029 39.9997L48.9967 40.1803C58.1731 40.4419 68.03 37.8199 72.7369 36.3625Z",
    fill: "#CCCCCC"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7738 38.1865L72.7801 37.8938C68.0857 39.3449 58.6596 41.8486 49.4956 41.8237C49.3458 41.8237 49.1898 41.8237 49.0399 41.8237L49.0337 42.0043C58.2101 42.2596 68.067 39.6376 72.7738 38.1865Z",
    fill: "#CCCCCC"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8122 40.0046L72.8184 39.7119C68.1241 41.163 58.6979 43.6667 49.534 43.6418C49.3841 43.6418 49.2281 43.6418 49.0783 43.6418L49.072 43.8224C58.2547 44.084 68.1116 41.462 72.8122 40.0046Z",
    fill: "#CCCCCC"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M72.854 41.824L72.8603 41.5312C68.1659 42.9824 58.7398 45.486 49.5758 45.4611C49.426 45.4611 49.27 45.4611 49.1201 45.4611L49.1139 45.6417C58.2903 45.9033 68.1472 43.2813 72.854 41.824Z",
    fill: "#CCCCCC"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8927 43.647L72.899 43.3542C68.2046 44.8054 58.7785 47.309 49.6145 47.2841C49.4647 47.2841 49.3087 47.2841 49.1588 47.2841L49.1526 47.4647C58.329 47.7201 68.1922 45.0981 72.8927 43.647Z",
    fill: "#CCCCCC"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9362 45.467L72.9424 45.1743C68.2481 46.6254 58.8219 49.1291 49.658 49.1042C49.5082 49.1042 49.3521 49.1042 49.2023 49.1042L49.196 49.2848C58.3725 49.5464 68.2294 46.9182 72.9362 45.467Z",
    fill: "#CCCCCC"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9729 47.2851L72.9792 46.9924C68.2848 48.4436 58.8587 50.9472 49.6947 50.9223C49.5449 50.9223 49.3889 50.9223 49.239 50.9223L49.2328 51.1029C58.4092 51.3645 68.2661 48.7425 72.9729 47.2851Z",
    fill: "#CCCCCC"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0115 49.1101L73.0177 48.8174C68.3234 50.2685 58.8973 52.7722 49.7333 52.7472C49.5835 52.7472 49.4274 52.7472 49.2776 52.7472L49.2714 52.9279C58.454 53.1832 68.3109 50.5612 73.0115 49.1101Z",
    fill: "#CCCCCC"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0556 50.9285L73.0618 50.6357C68.3675 52.0869 58.9413 54.5905 49.7774 54.5656C49.6276 54.5656 49.4715 54.5656 49.3217 54.5656L49.3154 54.7462C58.4919 55.0078 68.3487 52.3796 73.0556 50.9285Z",
    fill: "#CCCCCC"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0921 52.7475L73.0983 52.4548C68.404 53.906 58.9778 56.4096 49.8139 56.3847C49.6641 56.3847 49.508 56.3847 49.3582 56.3847L49.3519 56.5653C58.5284 56.8269 68.3852 54.2049 73.0921 52.7475Z",
    fill: "#CCCCCC"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1287 54.5725L73.1349 54.2798C68.4406 55.7309 59.0145 58.2346 49.8505 58.2097C49.7007 58.2097 49.5446 58.2097 49.3948 58.2097L49.3885 58.3903C58.5712 58.6456 68.4281 56.0236 73.1287 54.5725Z",
    fill: "#CCCCCC"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1725 56.3906L73.1787 56.0979C68.4844 57.549 59.0583 60.0527 49.8943 60.0278C49.7445 60.0278 49.5884 60.0278 49.4386 60.0278L49.4324 60.2084C58.6088 60.4637 68.4657 57.8417 73.1725 56.3906Z",
    fill: "#CCCCCC"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2108 58.21L73.2171 57.9172C68.5227 59.3684 59.0966 61.872 49.9326 61.8471C49.7828 61.8471 49.6268 61.8471 49.4769 61.8471L49.4707 62.0277C58.6471 62.2893 68.504 59.6673 73.2108 58.21Z",
    fill: "#CCCCCC"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2478 60.0283L73.2541 59.7356C68.5597 61.1867 59.1336 63.6904 49.9696 63.6655C49.8198 63.6655 49.6638 63.6655 49.5139 63.6655L49.5077 63.8461C58.6904 64.1076 68.5472 61.4857 73.2478 60.0283Z",
    fill: "#CCCCCC"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M97.365 95.0169L73.8371 79.6338L19.3029 111.048L42.8308 126.431L97.365 95.0169Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M19.3024 111.048L19.3086 114.523L42.8427 128.169L42.8303 126.431L19.3024 111.048Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M42.8306 126.431L42.843 128.169L97.3773 96.7547L97.3648 95.0171L42.8306 126.431Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M68.9869 84.6165L71.727 86.2854L76.4769 83.4894L73.7368 81.8206L68.9869 84.6165Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M44.7535 98.8839L47.4936 100.553L50.2025 98.9587L47.4624 97.2898L44.7535 98.8839Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M56.9384 95.7642L59.6784 97.4331L62.3935 95.8327L59.6535 94.1638L56.9384 95.7642Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M53.4489 97.8191L56.1889 99.4818L58.904 97.8876L56.164 96.2188L53.4489 97.8191Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M58.468 98.9152L61.2081 100.584L63.9232 98.9899L61.1831 97.321L58.468 98.9152Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M54.9908 100.965L57.7372 102.634L60.446 101.034L57.706 99.3647L54.9908 100.965Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M61.2013 101.557L63.9414 103.22L66.6565 101.625L63.9164 99.9565L61.2013 101.557Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M57.7241 103.599L60.4704 105.268L63.1793 103.667L60.4392 101.998L57.7241 103.599Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M62.7866 104.627L65.5267 106.296L68.2418 104.696L65.5017 103.027L62.7866 104.627Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M49.9651 99.8684L52.7052 101.537L55.4202 99.9369L52.6802 98.2681L49.9651 99.8684Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M41.2764 100.928L44.0164 102.597L46.7315 101.002L43.9915 99.3335L41.2764 100.928Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M46.4824 101.923L49.2225 103.586L51.9313 101.992L49.1975 100.323L46.4824 101.923Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M51.5205 103.008L54.2606 104.677L56.9757 103.076L54.2356 101.407L51.5205 103.008Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M42.993 103.973L45.7331 105.642L48.4482 104.042L45.7081 102.379L42.993 103.973Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M48.0488 105.05L50.7889 106.719L53.4977 105.125L50.7577 103.456L48.0488 105.05Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M44.5714 107.1L47.3115 108.769L50.0266 107.168L47.2865 105.5L44.5714 107.1Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M48.2238 96.8428L50.9638 98.5117L53.6789 96.9113L50.9389 95.2424L48.2238 96.8428Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M51.6936 94.7929L54.4399 96.4617L57.1488 94.8676L54.4087 93.1987L51.6936 94.7929Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M66.264 102.577L68.9979 104.246L71.713 102.652L68.9729 100.983L66.264 102.577Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M54.2539 105.642L56.994 107.311L59.7091 105.716L56.969 104.048L54.2539 105.642Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M50.7838 107.691L53.5239 109.353L56.2327 107.759L53.4927 106.09L50.7838 107.691Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M27.3799 109.11L30.1199 110.779L32.835 109.179L30.095 107.51L27.3799 109.11Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M37.8046 102.978L40.5446 104.646L43.2597 103.046L40.5197 101.377L37.8046 102.978Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M54.8088 113.328L57.5489 114.997L61.1628 112.867L58.4227 111.198L54.8088 113.328Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M51.3317 115.376L54.0717 117.045L56.7868 115.444L54.0468 113.775L51.3317 115.376Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M40.9141 121.51L43.6541 123.179L46.3692 121.579L43.6292 119.91L40.9141 121.51Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M39.5089 106.028L42.249 107.691L44.9641 106.096L42.224 104.427L39.5089 106.028Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M30.8573 107.068L33.5974 108.737L36.3125 107.136L33.5724 105.467L30.8573 107.068Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M36.0264 108.077L38.7602 109.745L41.4753 108.145L38.7352 106.482L36.0264 108.077Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M41.0947 109.142L43.841 110.81L46.5561 109.21L43.8161 107.541L41.0947 109.142Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M32.5371 110.132L35.2772 111.795L37.9923 110.201L35.2522 108.532L32.5371 110.132Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M37.6244 111.185L40.3645 112.854L43.0796 111.259L40.3395 109.591L37.6244 111.185Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M43.8348 111.776L46.5749 113.444L49.29 111.85L46.5499 110.181L43.8348 111.776Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M48.8921 112.805L51.6322 114.474L54.3473 112.873L51.6072 111.211L48.8921 112.805Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M40.3577 113.825L43.0977 115.494L45.8128 113.894L43.0728 112.225L40.3577 113.825Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M45.4199 114.852L48.16 116.515L50.8751 114.921L48.135 113.252L45.4199 114.852Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M36.8877 115.868L39.6278 117.537L42.3429 115.937L39.6028 114.268L36.8877 115.868Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M47.8616 117.418L50.6016 119.087L53.3167 117.487L50.5767 115.818L47.8616 117.418Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M30.675 115.276L33.4155 116.945L36.9612 119.107L38.9214 117.954L35.3756 115.793L36.131 115.345L33.3905 113.676L32.6352 114.124L30.675 115.276Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M44.3842 119.462L47.1242 121.131L49.8393 119.537L47.0993 117.868L44.3842 119.462Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M37.5681 119.474L40.3086 121.143L47.4 116.964L44.6596 115.295L37.5681 119.474Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M47.3066 109.734L50.0467 111.403L52.7618 109.803L50.0217 108.134L47.3066 109.734Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M52.3677 110.761L55.1015 112.43L57.8166 110.83L55.0828 109.161L52.3677 110.761Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M55.8396 108.718L58.5797 110.381L61.2948 108.787L58.5547 107.118L55.8396 108.718Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M59.3099 106.669L62.05 108.338L64.7651 106.738L62.0313 105.075L59.3099 106.669Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M59.1348 110.78L61.8752 112.449L78.7424 102.515L76.0019 100.853L59.1348 110.78Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M69.7357 100.535L72.4758 102.203L75.1846 100.603L72.4508 98.9404L69.7357 100.535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M64.6733 99.5076L67.4134 101.176L70.1285 99.5761L67.3884 97.9072L64.6733 99.5076Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M61.9381 96.8731L64.6782 98.5419L67.3933 96.9416L64.6532 95.2727L61.9381 96.8731Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M73.2061 98.4925L75.9461 100.161L78.6612 98.561L75.9212 96.8921L73.2061 98.4925Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M76.5015 100.554L79.2415 102.223L82.8617 100.093L80.1216 98.4243L76.5015 100.554Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M81.0286 97.8938L83.7686 99.5627L86.4837 97.9623L83.7437 96.2935L81.0286 97.8938Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M84.4984 95.8458L87.2385 97.5147L89.9536 95.9206L87.2135 94.2517L84.4984 95.8458Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M87.9756 93.8028L90.7157 95.4716L93.4308 93.8713L90.6907 92.2024L87.9756 93.8028Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M68.1505 97.4639L70.8906 99.1328L73.6057 97.5324L70.8656 95.8635L68.1505 97.4639Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M74.3662 85.5071L77.1063 87.1697L79.8214 85.5756L77.0813 83.9067L74.3662 85.5071Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M65.5902 86.615L68.3303 88.2839L71.0454 86.6835L68.3053 85.0146L65.5902 86.615Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M70.884 87.5564L73.6178 89.2253L76.333 87.6249L73.5991 85.9561L70.884 87.5564Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M75.7521 88.7379L78.4921 90.4068L83.242 87.6108L80.5019 85.9419L75.7521 88.7379Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M62.1201 88.6581L64.8602 90.327L67.5753 88.7328L64.8352 87.064L62.1201 88.6581Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M67.3943 89.6041L70.1344 91.273L72.8495 89.6789L70.1094 88.01L67.3943 89.6041Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M72.3628 90.7383L75.1029 92.4072L77.818 90.8068L75.0779 89.1379L72.3628 90.7383Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M58.6429 90.7071L61.383 92.3759L64.0981 90.7756L61.358 89.1067L58.6429 90.7071Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M78.4001 91.4292L81.1406 93.092L86.79 89.7663L84.0496 88.0972L78.4001 91.4292Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M63.9105 91.6597L66.6443 93.3286L69.3594 91.7282L66.6256 90.0593L63.9105 91.6597Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M83.6061 92.3702L86.3461 94.0328L90.1348 91.8035L87.3947 90.1409L83.6061 92.3702Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M68.8872 92.781L71.6273 94.4499L74.3424 92.8495L71.6023 91.1807L68.8872 92.781Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M55.1713 92.7508L57.9113 94.4196L60.6264 92.8193L57.8864 91.1504L55.1713 92.7508Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M75.0978 93.3719L77.8378 95.0407L80.5529 93.4404L77.8129 91.7715L75.0978 93.3719Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M60.4208 93.7156L63.1608 95.3783L65.8759 93.7841L63.1359 92.1152L60.4208 93.7156Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M80.1533 94.4004L82.8934 96.0693L85.6085 94.4689L82.8684 92.8L80.1533 94.4004Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M65.415 94.8294L68.1551 96.4983L70.8702 94.8979L68.1301 93.229L65.415 94.8294Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M71.6206 95.4149L74.3607 97.0838L77.0758 95.4897L74.3357 93.8208L71.6206 95.4149Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M76.6832 96.4425L79.4233 98.1114L82.1321 96.5173L79.3983 94.8484L76.6832 96.4425Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M34.3276 105.019L37.0677 106.688L39.7828 105.093L37.0427 103.425L34.3276 105.019Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M34.1541 113.234L36.8941 114.903L39.6092 113.303L36.8691 111.634L34.1541 113.234Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M27.1735 113.141L30.1507 114.959L34.6259 112.325L31.6425 110.513L27.1735 113.141Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M23.908 111.154L26.648 112.823L29.3631 111.229L26.6231 109.56L23.908 111.154Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M68.9869 84.5662L71.727 86.2351L76.4769 83.4391L73.7368 81.7703L68.9869 84.5662Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M44.7535 98.8343L47.4936 100.503L50.2025 98.9028L47.4624 97.2339L44.7535 98.8343Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M56.9384 95.7149L59.6784 97.3837L62.3935 95.7834L59.6535 94.1145L56.9384 95.7149Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M53.4489 97.7636L56.1889 99.4325L58.904 97.8383L56.164 96.1694L53.4489 97.7636Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M58.468 98.8655L61.2081 100.534L63.9232 98.934L61.1831 97.2651L58.468 98.8655Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M54.9908 100.909L57.7372 102.577L60.446 100.983L57.706 99.3145L54.9908 100.909Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M61.2013 101.501L63.9414 103.169L66.6565 101.575L63.9164 99.9065L61.2013 101.501Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M57.7241 103.549L60.4704 105.218L63.1793 103.618L60.4392 101.949L57.7241 103.549Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M62.7866 104.576L65.5267 106.245L68.2418 104.644L65.5017 102.976L62.7866 104.576Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M49.9651 99.8191L52.7052 101.488L55.4202 99.8876L52.6802 98.2188L49.9651 99.8191Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M41.2764 100.876L44.0164 102.545L46.7315 100.951L43.9915 99.2822L41.2764 100.876Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M46.4824 101.868L49.2225 103.537L51.9313 101.943L49.1975 100.274L46.4824 101.868Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M51.5205 102.957L54.2606 104.625L56.9757 103.025L54.2356 101.356L51.5205 102.957Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M42.993 103.923L45.7331 105.592L48.4482 103.991L45.7081 102.322L42.993 103.923Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M48.0488 105L50.7889 106.669L53.4977 105.069L50.7577 103.4L48.0488 105Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M44.5714 107.042L47.3115 108.711L50.0266 107.117L47.2865 105.448L44.5714 107.042Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M48.2238 96.7915L50.9638 98.4604L53.6789 96.86L50.9389 95.1912L48.2238 96.7915Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M51.6936 94.7436L54.4399 96.4124L57.1488 94.8183L54.4087 93.1494L51.6936 94.7436Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M66.264 102.528L68.9979 104.197L71.713 102.596L68.9729 100.934L66.264 102.528Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M54.2539 105.592L56.994 107.261L59.7091 105.661L56.969 103.992L54.2539 105.592Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M50.7838 107.634L53.5239 109.303L56.2327 107.709L53.4927 106.04L50.7838 107.634Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M27.3799 109.062L30.1199 110.731L32.835 109.131L30.095 107.462L27.3799 109.062Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M37.8046 102.926L40.5446 104.595L43.2597 102.995L40.5197 101.326L37.8046 102.926Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M54.8088 113.277L57.5489 114.946L61.1628 112.816L58.4227 111.147L54.8088 113.277Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M51.3317 115.319L54.0717 116.988L56.7868 115.394L54.0468 113.725L51.3317 115.319Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M40.9141 121.461L43.6541 123.124L46.3692 121.53L43.6292 119.861L40.9141 121.461Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M39.5089 105.971L42.249 107.64L44.9641 106.046L42.224 104.377L39.5089 105.971Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M30.8573 107.012L33.5974 108.681L36.3125 107.087L33.5724 105.418L30.8573 107.012Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M36.0264 108.028L38.7602 109.697L41.4753 108.096L38.7352 106.427L36.0264 108.028Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M41.0947 109.091L43.841 110.76L46.5561 109.16L43.8161 107.491L41.0947 109.091Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M32.5371 110.076L35.2772 111.744L37.9923 110.15L35.2522 108.481L32.5371 110.076Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M37.6244 111.135L40.3645 112.804L43.0796 111.204L40.3395 109.541L37.6244 111.135Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M43.8348 111.726L46.5749 113.395L49.29 111.794L46.5499 110.125L43.8348 111.726Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M48.8921 112.754L51.6322 114.423L54.3473 112.823L51.6072 111.154L48.8921 112.754Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M40.3577 113.769L43.0977 115.438L45.8128 113.844L43.0728 112.175L40.3577 113.769Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M45.4199 114.797L48.16 116.465L50.8751 114.871L48.135 113.202L45.4199 114.797Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M36.8877 115.82L39.6278 117.489L42.3429 115.888L39.6028 114.219L36.8877 115.82Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M47.8616 117.369L50.6016 119.038L53.3167 117.438L50.5767 115.769L47.8616 117.369Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M30.675 115.227L33.4155 116.896L36.9612 119.051L38.9214 117.905L35.3756 115.744L36.131 115.296L33.3905 113.627L32.6352 114.075L30.675 115.227Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M44.3842 119.412L47.1242 121.081L49.8393 119.48L47.0993 117.812L44.3842 119.412Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M37.5681 119.424L40.3086 121.087L47.4 116.914L44.6596 115.245L37.5681 119.424Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M47.3066 109.684L50.0467 111.353L52.7618 109.753L50.0217 108.084L47.3066 109.684Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M52.3677 110.712L55.1015 112.381L57.8166 110.78L55.0828 109.111L52.3677 110.712Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M55.8396 108.662L58.5797 110.331L61.2948 108.736L58.5547 107.068L55.8396 108.662Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M59.3099 106.621L62.05 108.29L64.7651 106.689L62.0313 105.02L59.3099 106.621Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M59.1348 110.729L61.8752 112.398L78.7424 102.465L76.0019 100.796L59.1348 110.729Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M69.7357 100.485L72.4758 102.154L75.1846 100.553L72.4508 98.8845L69.7357 100.485Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M64.6733 99.4576L67.4134 101.126L70.1285 99.5261L67.3884 97.8572L64.6733 99.4576Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M61.9381 96.8238L64.6782 98.4926L67.3933 96.8923L64.6532 95.2234L61.9381 96.8238Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M73.2061 98.4422L75.9461 100.105L78.6612 98.5107L75.9212 96.8418L73.2061 98.4422Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M76.5015 100.505L79.2415 102.174L82.8617 100.044L80.1216 98.375L76.5015 100.505Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M81.0286 97.8448L83.7686 99.5074L86.4837 97.9133L83.7437 96.2444L81.0286 97.8448Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M84.4984 95.7954L87.2385 97.4643L89.9536 95.8639L87.2135 94.1951L84.4984 95.7954Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M87.9756 93.7537L90.7157 95.4226L93.4308 93.8222L90.6907 92.1533L87.9756 93.7537Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M68.1505 97.4139L70.8906 99.0827L73.6057 97.4823L70.8656 95.8135L68.1505 97.4139Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M74.3662 85.4506L77.1063 87.1195L79.8214 85.5191L77.0813 83.8564L74.3662 85.4506Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M65.5902 86.5657L68.3303 88.2346L71.0454 86.6342L68.3053 84.9653L65.5902 86.5657Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M70.884 87.5061L73.6178 89.175L76.333 87.5746L73.5991 85.9058L70.884 87.5061Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M75.7521 88.6895L78.4921 90.3584L83.242 87.5624L80.5019 85.8936L75.7521 88.6895Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M62.1201 88.6075L64.8602 90.2763L67.5753 88.676L64.8352 87.0071L62.1201 88.6075Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M67.3943 89.5551L70.1344 91.2239L72.8495 89.6236L70.1094 87.9609L67.3943 89.5551Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M72.3628 90.6883L75.1029 92.3571L77.818 90.7568L75.0779 89.0879L72.3628 90.6883Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M58.6429 90.657L61.383 92.3197L64.0981 90.7255L61.358 89.0566L58.6429 90.657Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M78.4001 91.3729L81.1406 93.042L86.79 89.7162L84.0496 88.0471L78.4001 91.3729Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M63.9105 91.6096L66.6443 93.2785L69.3594 91.6781L66.6256 90.0093L63.9105 91.6096Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M83.6061 92.3133L86.3461 93.9822L90.1348 91.7529L87.3947 90.084L83.6061 92.3133Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M68.8872 92.7317L71.6273 94.4006L74.3424 92.8002L71.6023 91.1313L68.8872 92.7317Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M55.1713 92.6995L57.9113 94.3684L60.6264 92.768L57.8864 91.0991L55.1713 92.6995Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M75.0978 93.3228L77.8378 94.9917L80.5529 93.3913L77.8129 91.7224L75.0978 93.3228Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M60.4208 93.6584L63.1608 95.3272L65.8759 93.7268L63.1359 92.0642L60.4208 93.6584Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M80.1533 94.3501L82.8934 96.019L85.6085 94.4186L82.8684 92.7498L80.1533 94.3501Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M65.415 94.7731L68.1551 96.442L70.8702 94.8478L68.1301 93.179L65.415 94.7731Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M71.6206 95.3668L74.3607 97.0357L77.0758 95.4416L74.3357 93.7727L71.6206 95.3668Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M76.6832 96.3932L79.4233 98.0621L82.1321 96.4617L79.3983 94.7991L76.6832 96.3932Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M34.3276 104.969L37.0677 106.638L39.7828 105.038L37.0427 103.369L34.3276 104.969Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M34.1541 113.183L36.8941 114.852L39.6092 113.252L36.8691 111.583L34.1541 113.183Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M27.1735 113.089L30.1507 114.907L34.6259 112.273L31.6425 110.455L27.1735 113.089Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M23.908 111.104L26.648 112.773L29.3631 111.172L26.6231 109.503L23.908 111.104Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M68.9869 84.4346L71.727 86.1035L76.4769 83.3075L73.7368 81.6387L68.9869 84.4346Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M44.7535 98.7036L47.4936 100.373L50.2025 98.7721L47.4624 97.1033L44.7535 98.7036Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M56.9384 95.5833L59.6784 97.2522L62.3935 95.6518L59.6535 93.9829L56.9384 95.5833Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M53.4489 97.6392L56.1889 99.3018L58.904 97.7077L56.164 96.0388L53.4489 97.6392Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M58.468 98.7343L61.2081 100.403L63.9232 98.809L61.1831 97.1401L58.468 98.7343Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M54.9908 100.777L57.7372 102.446L60.446 100.852L57.706 99.1829L54.9908 100.777Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M61.2013 101.369L63.9414 103.038L66.6565 101.444L63.9164 99.7747L61.2013 101.369Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M57.7241 103.418L60.4704 105.087L63.1793 103.486L60.4392 101.817L57.7241 103.418Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M62.7866 104.447L65.5267 106.116L68.2418 104.516L65.5017 102.847L62.7866 104.447Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M49.9651 99.6875L52.7052 101.356L55.4202 99.756L52.6802 98.0872L49.9651 99.6875Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M41.2764 100.748L44.0164 102.417L46.7315 100.822L43.9915 99.1536L41.2764 100.748Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M46.4824 101.736L49.2225 103.405L51.9313 101.811L49.1975 100.142L46.4824 101.736Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M51.5205 102.828L54.2606 104.497L56.9757 102.896L54.2356 101.228L51.5205 102.828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M42.993 103.792L45.7331 105.461L48.4482 103.86L45.7081 102.191L42.993 103.792Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M48.0488 104.87L50.7889 106.539L53.4977 104.945L50.7577 103.276L48.0488 104.87Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M44.5714 106.913L47.3115 108.582L50.0266 106.987L47.2865 105.319L44.5714 106.913Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M48.2238 96.6609L50.9638 98.3298L53.6789 96.7294L50.9389 95.0605L48.2238 96.6609Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M51.6936 94.612L54.4399 96.2808L57.1488 94.6867L54.4087 93.0178L51.6936 94.612Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M66.264 102.397L68.9979 104.066L71.713 102.472L68.9729 100.803L66.264 102.397Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M54.2539 105.461L56.994 107.13L59.7091 105.53L56.969 103.861L54.2539 105.461Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M50.7838 107.504L53.5239 109.172L56.2327 107.578L53.4927 105.909L50.7838 107.504Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M27.3799 108.93L30.1199 110.599L32.835 108.999L30.095 107.33L27.3799 108.93Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M37.8046 102.796L40.5446 104.465L43.2597 102.864L40.5197 101.195L37.8046 102.796Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M54.8088 113.146L57.5489 114.815L61.1628 112.685L58.4227 111.017L54.8088 113.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M51.3317 115.196L54.0717 116.865L56.7868 115.264L54.0468 113.595L51.3317 115.196Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M40.9141 121.33L43.6541 122.998L46.3692 121.398L43.6292 119.729L40.9141 121.33Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M39.5089 105.848L42.249 107.511L44.9641 105.916L42.224 104.248L39.5089 105.848Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M30.8573 106.881L33.5974 108.549L36.3125 106.955L33.5724 105.286L30.8573 106.881Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M36.0264 107.896L38.7602 109.565L41.4753 107.965L38.7352 106.296L36.0264 107.896Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M41.0947 108.961L43.841 110.63L46.5561 109.029L43.8161 107.36L41.0947 108.961Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M32.5371 109.946L35.2772 111.615L37.9923 110.021L35.2522 108.352L32.5371 109.946Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M37.6244 111.005L40.3645 112.674L43.0796 111.08L40.3395 109.411L37.6244 111.005Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M43.8348 111.596L46.5749 113.264L49.29 111.664L46.5499 110.001L43.8348 111.596Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M48.8921 112.623L51.6322 114.292L54.3473 112.691L51.6072 111.022L48.8921 112.623Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M40.3577 113.646L43.0977 115.314L45.8128 113.714L43.0728 112.045L40.3577 113.646Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M45.4199 114.672L48.16 116.335L50.8751 114.741L48.135 113.072L45.4199 114.672Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M36.8877 115.688L39.6278 117.357L42.3429 115.757L39.6028 114.088L36.8877 115.688Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M47.8616 117.239L50.6016 118.907L53.3167 117.307L50.5767 115.638L47.8616 117.239Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M30.675 115.095L33.4155 116.765L36.9612 118.926L38.9214 117.774L35.3756 115.612L36.131 115.164L33.3905 113.495L32.6352 113.943L30.675 115.095Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M44.3842 119.282L47.1242 120.951L49.8393 119.35L47.0993 117.688L44.3842 119.282Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M37.5681 119.294L40.3086 120.957L47.4 116.784L44.6596 115.115L37.5681 119.294Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M47.3066 109.553L50.0467 111.222L52.7618 109.622L50.0217 107.953L47.3066 109.553Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M52.3677 110.58L55.1015 112.249L57.8166 110.649L55.0828 108.98L52.3677 110.58Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M55.8396 108.538L58.5797 110.201L61.2948 108.607L58.5547 106.938L55.8396 108.538Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M59.3099 106.489L62.05 108.158L64.7651 106.558L62.0313 104.889L59.3099 106.489Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M59.1348 110.6L61.8752 112.27L78.7424 102.336L76.0019 100.667L59.1348 110.6Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M69.7357 100.354L72.4758 102.023L75.1846 100.423L72.4508 98.7539L69.7357 100.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M64.6733 99.3267L67.4134 100.996L70.1285 99.3952L67.3884 97.7263L64.6733 99.3267Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M61.9381 96.6922L64.6782 98.361L67.3933 96.7607L64.6532 95.0918L61.9381 96.6922Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M73.2061 98.3106L75.9461 99.9732L78.6612 98.3791L75.9212 96.7102L73.2061 98.3106Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M76.5015 100.373L79.2415 102.042L82.8617 99.9123L80.1216 98.2434L76.5015 100.373Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M81.0286 97.7139L83.7686 99.3828L86.4837 97.7824L83.7437 96.1135L81.0286 97.7139Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M84.4984 95.6642L87.2385 97.3331L89.9536 95.7389L87.2135 94.0701L84.4984 95.6642Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M87.9756 93.6219L90.7157 95.2907L93.4308 93.6904L90.6907 92.0215L87.9756 93.6219Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M68.1505 97.284L70.8906 98.9528L73.6057 97.3525L70.8656 95.6836L68.1505 97.284Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M74.3662 85.32L77.1063 86.9888L79.8214 85.3885L77.0813 83.7258L74.3662 85.32Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M65.5902 86.4351L68.3303 88.104L71.0454 86.5036L68.3053 84.8347L65.5902 86.4351Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M70.884 87.3745L73.6178 89.0434L76.333 87.443L73.5991 85.7742L70.884 87.3745Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M75.7521 88.5589L78.4921 90.2278L83.242 87.4318L80.5019 85.7629L75.7521 88.5589Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M62.1201 88.4772L64.8602 90.1461L67.5753 88.5457L64.8352 86.8831L62.1201 88.4772Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M67.3943 89.4232L70.1344 91.0921L72.8495 89.498L70.1094 87.8291L67.3943 89.4232Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M72.3628 90.5584L75.1029 92.2272L77.818 90.6269L75.0779 88.958L72.3628 90.5584Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M58.6429 90.5271L61.383 92.196L64.0981 90.5956L61.358 88.9268L58.6429 90.5271Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M78.4001 91.243L81.1406 92.9121L86.79 89.5863L84.0496 87.9172L78.4001 91.243Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M63.9105 91.4798L66.6443 93.1486L69.3594 91.5483L66.6256 89.8794L63.9105 91.4798Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M83.6061 92.1879L86.3461 93.8506L90.1348 91.6213L87.3947 89.9524L83.6061 92.1879Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M68.8872 92.6001L71.6273 94.269L74.3424 92.6686L71.6023 90.9998L68.8872 92.6001Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M55.1713 92.5699L57.9113 94.2387L60.6264 92.6384L57.8864 90.9695L55.1713 92.5699Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M75.0978 93.1912L77.8378 94.8601L80.5529 93.2597L77.8129 91.5908L75.0978 93.1912Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M60.4208 93.5297L63.1608 95.1986L65.8759 93.5982L63.1359 91.9355L60.4208 93.5297Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M80.1533 94.2195L82.8934 95.8884L85.6085 94.288L82.8684 92.6191L80.1533 94.2195Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M65.415 94.6432L68.1551 96.3121L70.8702 94.718L68.1301 93.0491L65.415 94.6432Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M71.6206 95.235L74.3607 96.9039L77.0758 95.3098L74.3357 93.6409L71.6206 95.235Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M76.6832 96.2626L79.4233 97.9315L82.1321 96.3373L79.3983 94.6685L76.6832 96.2626Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M34.3276 104.838L37.0677 106.507L39.7828 104.907L37.0427 103.238L34.3276 104.838Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M34.1541 113.053L36.8941 114.722L39.6092 113.121L36.8691 111.452L34.1541 113.053Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M27.1735 112.96L30.1507 114.778L34.6259 112.144L31.6425 110.332L27.1735 112.96Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M23.908 110.973L26.648 112.642L29.3631 111.041L26.6231 109.373L23.908 110.973Z",
    fill: "black"
  }))), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3654 93.7708L73.8375 78.3877L19.3032 109.802L42.8311 125.185L97.3654 93.7708Z",
    fill: "url(#paint22_linear)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3026 109.802L19.3089 113.277L42.843 126.922L42.8305 125.185L19.3026 109.802Z",
    fill: "url(#paint23_linear)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8308 125.185L42.8433 126.922L97.3776 95.5084L97.3651 93.7708L42.8308 125.185Z",
    fill: "url(#paint24_linear)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9844 83.3692L71.7244 85.0381L76.4743 82.2421L73.7342 80.5732L68.9844 83.3692Z",
    fill: "url(#paint25_linear)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7512 97.6376L47.4913 99.3065L50.2001 97.7123L47.4601 96.0435L44.7512 97.6376Z",
    fill: "url(#paint26_linear)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M56.936 94.5179L59.6761 96.1867L62.3912 94.5864L59.6511 92.9175L56.936 94.5179Z",
    fill: "url(#paint27_linear)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4464 96.5728L56.1865 98.2354L58.9016 96.6413L56.1615 94.9724L53.4464 96.5728Z",
    fill: "url(#paint28_linear)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4647 97.6689L61.2048 99.3377L63.9199 97.7436L61.1798 96.0747L58.4647 97.6689Z",
    fill: "url(#paint29_linear)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9879 99.7168L57.7342 101.386L60.4431 99.7853L57.703 98.1165L54.9879 99.7168Z",
    fill: "url(#paint30_linear)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1993 100.31L63.9394 101.972L66.6545 100.378L63.9144 98.7092L61.1993 100.31Z",
    fill: "url(#paint31_linear)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7234 102.353L60.4697 104.022L63.1786 102.422L60.4385 100.753L57.7234 102.353Z",
    fill: "url(#paint32_linear)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7842 103.38L65.5242 105.049L68.2393 103.448L65.4993 101.779L62.7842 103.38Z",
    fill: "url(#paint33_linear)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9644 98.6216L52.7044 100.29L55.4195 98.6901L52.6795 97.0212L49.9644 98.6216Z",
    fill: "url(#paint34_linear)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2742 99.6799L44.0142 101.349L46.7293 99.7546L43.9893 98.0857L41.2742 99.6799Z",
    fill: "url(#paint35_linear)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4794 100.677L49.2194 102.339L51.9283 100.745L49.1945 99.0762L46.4794 100.677Z",
    fill: "url(#paint36_linear)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5183 101.76L54.2584 103.429L56.9735 101.829L54.2334 100.16L51.5183 101.76Z",
    fill: "url(#paint37_linear)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9906 102.725L45.7307 104.394L48.4458 102.794L45.7057 101.131L42.9906 102.725Z",
    fill: "url(#paint38_linear)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0483 103.804L50.7884 105.473L53.4973 103.879L50.7572 102.21L48.0483 103.804Z",
    fill: "url(#paint39_linear)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5704 105.851L47.3105 107.52L50.0256 105.92L47.2855 104.251L44.5704 105.851Z",
    fill: "url(#paint40_linear)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2214 95.5945L50.9615 97.2634L53.6766 95.663L50.9365 93.9941L48.2214 95.5945Z",
    fill: "url(#paint41_linear)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6932 93.5475L54.4395 95.2164L57.1484 93.6222L54.4083 91.9534L51.6932 93.5475Z",
    fill: "url(#paint42_linear)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2634 101.331L68.9973 103L71.7124 101.406L68.9723 99.7368L66.2634 101.331Z",
    fill: "url(#paint43_linear)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2518 104.395L56.9919 106.064L59.707 104.47L56.9669 102.801L54.2518 104.395Z",
    fill: "url(#paint44_linear)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7815 106.444L53.5216 108.107L56.2304 106.513L53.4903 104.844L50.7815 106.444Z",
    fill: "url(#paint45_linear)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3776 107.863L30.1176 109.532L32.8327 107.932L30.0927 106.263L27.3776 107.863Z",
    fill: "url(#paint46_linear)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M37.804 101.729L40.544 103.398L43.2591 101.798L40.5191 100.129L37.804 101.729Z",
    fill: "url(#paint47_linear)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8081 112.081L57.5482 113.75L61.1621 111.62L58.422 109.951L54.8081 112.081Z",
    fill: "url(#paint48_linear)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3314 114.13L54.0715 115.799L56.7866 114.198L54.0465 112.529L51.3314 114.13Z",
    fill: "url(#paint49_linear)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9117 120.264L43.6518 121.933L46.3669 120.333L43.6268 118.664L40.9117 120.264Z",
    fill: "url(#paint50_linear)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5087 104.781L42.2487 106.444L44.9638 104.85L42.2238 103.181L39.5087 104.781Z",
    fill: "url(#paint51_linear)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8568 105.822L33.5969 107.491L36.312 105.89L33.5719 104.221L30.8568 105.822Z",
    fill: "url(#paint52_linear)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0242 106.83L38.758 108.499L41.4731 106.898L38.733 105.236L36.0242 106.83Z",
    fill: "url(#paint53_linear)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0941 107.896L43.8404 109.565L46.5555 107.964L43.8155 106.295L41.0941 107.896Z",
    fill: "url(#paint54_linear)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5349 108.884L35.275 110.547L37.9901 108.953L35.25 107.284L32.5349 108.884Z",
    fill: "url(#paint55_linear)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6219 109.938L40.362 111.607L43.0771 110.013L40.337 108.344L37.6219 109.938Z",
    fill: "url(#paint56_linear)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8344 110.53L46.5744 112.199L49.2895 110.604L46.5494 108.936L43.8344 110.53Z",
    fill: "url(#paint57_linear)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8899 111.557L51.63 113.226L54.3451 111.626L51.605 109.963L48.8899 111.557Z",
    fill: "url(#paint58_linear)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3572 112.579L43.0972 114.248L45.8123 112.647L43.0723 110.978L40.3572 112.579Z",
    fill: "url(#paint59_linear)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4197 113.606L48.1597 115.269L50.8748 113.675L48.1348 112.006L45.4197 113.606Z",
    fill: "url(#paint60_linear)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8871 114.62L39.6271 116.289L42.3422 114.689L39.6022 113.02L36.8871 114.62Z",
    fill: "url(#paint61_linear)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8611 116.173L50.6011 117.842L53.3162 116.241L50.5762 114.572L47.8611 116.173Z",
    fill: "url(#paint62_linear)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6747 114.031L33.4151 115.7L36.9609 117.861L38.921 116.709L35.3753 114.548L36.1306 114.099L33.3902 112.43L32.6348 112.879L30.6747 114.031Z",
    fill: "url(#paint63_linear)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3829 118.215L47.123 119.884L49.8381 118.289L47.098 116.621L44.3829 118.215Z",
    fill: "url(#paint64_linear)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5659 118.229L40.3064 119.898L47.3978 115.719L44.6574 114.05L37.5659 118.229Z",
    fill: "url(#paint65_linear)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3043 108.487L50.0444 110.156L52.7595 108.556L50.0194 106.887L47.3043 108.487Z",
    fill: "url(#paint66_linear)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3671 109.515L55.1009 111.184L57.816 109.583L55.0822 107.914L52.3671 109.515Z",
    fill: "url(#paint67_linear)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M55.837 107.472L58.5771 109.135L61.2922 107.54L58.5521 105.872L55.837 107.472Z",
    fill: "url(#paint68_linear)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3088 105.422L62.0489 107.091L64.764 105.491L62.0302 103.828L59.3088 105.422Z",
    fill: "url(#paint69_linear)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M59.134 109.534L61.8745 111.203L78.7417 101.269L76.0012 99.6062L59.134 109.534Z",
    fill: "url(#paint70_linear)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7335 99.2882L72.4736 100.957L75.1824 99.3567L72.4486 97.6941L69.7335 99.2882Z",
    fill: "url(#paint71_linear)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6708 98.2595L67.4109 99.9284L70.1259 98.328L67.3859 96.6592L64.6708 98.2595Z",
    fill: "url(#paint72_linear)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9375 95.6258L64.6776 97.2946L67.3927 95.6943L64.6526 94.0254L61.9375 95.6258Z",
    fill: "url(#paint73_linear)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2035 97.2452L75.9436 98.914L78.6586 97.3137L75.9186 95.6448L73.2035 97.2452Z",
    fill: "url(#paint74_linear)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5005 99.3067L79.2406 100.976L82.8607 98.8459L80.1206 97.177L76.5005 99.3067Z",
    fill: "url(#paint75_linear)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M81.026 96.6477L83.7661 98.3166L86.4812 96.7162L83.7411 95.0474L81.026 96.6477Z",
    fill: "url(#paint76_linear)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4961 94.5978L87.2362 96.2667L89.9512 94.6725L87.2112 93.0037L84.4961 94.5978Z",
    fill: "url(#paint77_linear)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9733 92.5557L90.7133 94.2246L93.4284 92.6242L90.6884 90.9553L87.9733 92.5557Z",
    fill: "url(#paint78_linear)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1482 96.2178L70.8883 97.8867L73.6034 96.2863L70.8633 94.6174L68.1482 96.2178Z",
    fill: "url(#paint79_linear)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3654 84.261L77.1054 85.9236L79.8205 84.3295L77.0804 82.6606L74.3654 84.261Z",
    fill: "url(#paint80_linear)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5895 85.3689L68.3295 87.0378L71.0446 85.4374L68.3046 83.7686L65.5895 85.3689Z",
    fill: "url(#paint81_linear)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8843 86.3084L73.6181 87.9773L76.3332 86.3769L73.5994 84.708L70.8843 86.3084Z",
    fill: "url(#paint82_linear)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7522 87.4937L78.4923 89.1626L83.2421 86.3666L80.5021 84.6978L75.7522 87.4937Z",
    fill: "url(#paint83_linear)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1167 87.4123L64.8568 89.0811L67.5719 87.487L64.8318 85.8181L62.1167 87.4123Z",
    fill: "url(#paint84_linear)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3944 88.3583L70.1345 90.0272L72.8496 88.433L70.1095 86.7642L67.3944 88.3583Z",
    fill: "url(#paint85_linear)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3617 89.4925L75.1018 91.1613L77.8169 89.561L75.0768 87.8921L72.3617 89.4925Z",
    fill: "url(#paint86_linear)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6407 89.4612L61.3808 91.1301L64.0959 89.5297L61.3558 87.8608L58.6407 89.4612Z",
    fill: "url(#paint87_linear)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3972 90.1843L81.1377 91.8471L86.7871 88.5214L84.0467 86.8523L78.3972 90.1843Z",
    fill: "url(#paint88_linear)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9094 90.4139L66.6432 92.0827L69.3583 90.4823L66.6245 88.8135L63.9094 90.4139Z",
    fill: "url(#paint89_linear)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6052 91.1241L86.3453 92.7867L90.1339 90.5574L87.3939 88.8948L83.6052 91.1241Z",
    fill: "url(#paint90_linear)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8845 91.535L71.6246 93.2038L74.3397 91.6035L71.5996 89.9346L68.8845 91.535Z",
    fill: "url(#paint91_linear)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1703 91.5027L57.9104 93.1716L60.6254 91.5712L57.8854 89.9023L55.1703 91.5027Z",
    fill: "url(#paint92_linear)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0968 92.1267L77.8369 93.7956L80.552 92.1952L77.8119 90.5264L75.0968 92.1267Z",
    fill: "url(#paint93_linear)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4204 92.4688L63.1605 94.1314L65.8756 92.5373L63.1355 90.8684L60.4204 92.4688Z",
    fill: "url(#paint94_linear)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1534 93.1546L82.8935 94.8235L85.6086 93.2231L82.8685 91.5542L80.1534 93.1546Z",
    fill: "url(#paint95_linear)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4154 93.5845L68.1555 95.2534L70.8706 93.653L68.1305 91.9841L65.4154 93.5845Z",
    fill: "url(#paint96_linear)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6204 94.171L74.3604 95.8399L77.0755 94.2458L74.3355 92.5769L71.6204 94.171Z",
    fill: "url(#paint97_linear)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6824 95.1967L79.4224 96.8656L82.1313 95.2714L79.3975 93.6025L76.6824 95.1967Z",
    fill: "url(#paint98_linear)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3268 103.772L37.0668 105.441L39.7819 103.847L37.0419 102.178L34.3268 103.772Z",
    fill: "url(#paint99_linear)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1516 111.987L36.8917 113.656L39.6068 112.056L36.8667 110.387L34.1516 111.987Z",
    fill: "url(#paint100_linear)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1729 111.892L30.1501 113.711L34.6253 111.077L31.6418 109.265L27.1729 111.892Z",
    fill: "url(#paint101_linear)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9076 109.907L26.6477 111.576L29.3628 109.982L26.6227 108.313L23.9076 109.907Z",
    fill: "url(#paint102_linear)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9841 83.3187L71.7242 84.9876L76.4741 82.1916L73.734 80.5227L68.9841 83.3187Z",
    fill: "url(#paint103_linear)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M44.751 97.5877L47.491 99.2565L50.1999 97.6562L47.4598 95.9873L44.751 97.5877Z",
    fill: "url(#paint104_linear)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M56.936 94.4663L59.6761 96.1352L62.3912 94.5348L59.6511 92.866L56.936 94.4663Z",
    fill: "url(#paint105_linear)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4464 96.516L56.1865 98.1849L58.9016 96.5907L56.1615 94.9219L53.4464 96.516Z",
    fill: "url(#paint106_linear)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4647 97.6194L61.2048 99.2883L63.9199 97.6879L61.1798 96.019L58.4647 97.6194Z",
    fill: "url(#paint107_linear)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9879 99.6606L57.7342 101.329L60.4431 99.7353L57.703 98.0664L54.9879 99.6606Z",
    fill: "url(#paint108_linear)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1993 100.253L63.9394 101.922L66.6545 100.328L63.9144 98.6592L61.1993 100.253Z",
    fill: "url(#paint109_linear)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7229 102.301L60.4692 103.97L63.1781 102.37L60.438 100.701L57.7229 102.301Z",
    fill: "url(#paint110_linear)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7842 103.33L65.5242 104.999L68.2393 103.398L65.4993 101.729L62.7842 103.33Z",
    fill: "url(#paint111_linear)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9641 98.5716L52.7042 100.24L55.4193 98.6401L52.6792 96.9712L49.9641 98.5716Z",
    fill: "url(#paint112_linear)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2739 99.6288L44.014 101.298L46.7291 99.7035L43.989 98.0347L41.2739 99.6288Z",
    fill: "url(#paint113_linear)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4791 100.621L49.2192 102.29L51.9281 100.695L49.1942 99.0266L46.4791 100.621Z",
    fill: "url(#paint114_linear)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5182 101.71L54.2583 103.379L56.9734 101.778L54.2333 100.11L51.5182 101.71Z",
    fill: "url(#paint115_linear)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9904 102.675L45.7304 104.344L48.4455 102.743L45.7055 101.074L42.9904 102.675Z",
    fill: "url(#paint116_linear)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0482 103.755L50.7883 105.424L53.4971 103.823L50.7571 102.155L48.0482 103.755Z",
    fill: "url(#paint117_linear)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5707 105.796L47.3107 107.465L50.0258 105.871L47.2858 104.202L44.5707 105.796Z",
    fill: "url(#paint118_linear)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2212 95.545L50.9613 97.2138L53.6764 95.6135L50.9363 93.9446L48.2212 95.545Z",
    fill: "url(#paint119_linear)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M51.693 93.497L54.4393 95.1659L57.1482 93.5717L54.4081 91.9028L51.693 93.497Z",
    fill: "url(#paint120_linear)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2632 101.28L68.997 102.949L71.7121 101.349L68.972 99.6863L66.2632 101.28Z",
    fill: "url(#paint121_linear)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2516 104.345L56.9916 106.013L59.7067 104.413L56.9667 102.744L54.2516 104.345Z",
    fill: "url(#paint122_linear)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7812 106.388L53.5213 108.056L56.2302 106.462L53.4901 104.793L50.7812 106.388Z",
    fill: "url(#paint123_linear)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3776 107.813L30.1176 109.482L32.8327 107.882L30.0927 106.213L27.3776 107.813Z",
    fill: "url(#paint124_linear)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8037 101.679L40.5438 103.348L43.2589 101.747L40.5188 100.078L37.8037 101.679Z",
    fill: "url(#paint125_linear)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8081 112.028L57.5482 113.697L61.1621 111.568L58.422 109.899L54.8081 112.028Z",
    fill: "url(#paint126_linear)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3314 114.07L54.0715 115.739L56.7866 114.145L54.0465 112.476L51.3314 114.07Z",
    fill: "url(#paint127_linear)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9117 120.214L43.6518 121.876L46.3669 120.282L43.6268 118.613L40.9117 120.214Z",
    fill: "url(#paint128_linear)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5082 104.725L42.2482 106.394L44.9633 104.799L42.2233 103.131L39.5082 104.725Z",
    fill: "url(#paint129_linear)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8563 105.766L33.5964 107.434L36.3115 105.84L33.5714 104.171L30.8563 105.766Z",
    fill: "url(#paint130_linear)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0232 106.78L38.757 108.449L41.4721 106.849L38.732 105.18L36.0232 106.78Z",
    fill: "url(#paint131_linear)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0938 107.845L43.8401 109.514L46.5552 107.913L43.8151 106.244L41.0938 107.845Z",
    fill: "url(#paint132_linear)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5344 108.828L35.2745 110.497L37.9896 108.903L35.2495 107.234L32.5344 108.828Z",
    fill: "url(#paint133_linear)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6208 109.887L40.3609 111.556L43.076 109.955L40.3359 108.293L37.6208 109.887Z",
    fill: "url(#paint134_linear)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8339 110.479L46.5739 112.148L49.289 110.548L46.549 108.879L43.8339 110.479Z",
    fill: "url(#paint135_linear)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8895 111.507L51.6296 113.176L54.3447 111.575L51.6046 109.906L48.8895 111.507Z",
    fill: "url(#paint136_linear)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3567 112.522L43.0968 114.191L45.8119 112.597L43.0718 110.928L40.3567 112.522Z",
    fill: "url(#paint137_linear)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4194 113.55L48.1595 115.219L50.8746 113.625L48.1345 111.956L45.4194 113.55Z",
    fill: "url(#paint138_linear)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8857 114.57L39.6258 116.238L42.3409 114.638L39.6008 112.969L36.8857 114.57Z",
    fill: "url(#paint139_linear)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8608 116.123L50.6009 117.791L53.316 116.191L50.5759 114.522L47.8608 116.123Z",
    fill: "url(#paint140_linear)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6743 113.981L33.4148 115.65L36.9605 117.805L38.9206 116.659L35.3749 114.498L36.1302 114.049L33.3898 112.38L32.6345 112.829L30.6743 113.981Z",
    fill: "url(#paint141_linear)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3827 118.164L47.1228 119.833L49.8378 118.233L47.0978 116.564L44.3827 118.164Z",
    fill: "url(#paint142_linear)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5657 118.178L40.3061 119.841L47.3976 115.669L44.6571 114L37.5657 118.178Z",
    fill: "url(#paint143_linear)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3043 108.437L50.0444 110.105L52.7595 108.505L50.0194 106.836L47.3043 108.437Z",
    fill: "url(#paint144_linear)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3668 109.464L55.1006 111.133L57.8157 109.533L55.0819 107.864L52.3668 109.464Z",
    fill: "url(#paint145_linear)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8368 107.415L58.5769 109.084L61.292 107.49L58.5519 105.821L55.8368 107.415Z",
    fill: "url(#paint146_linear)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3088 105.372L62.0489 107.041L64.764 105.441L62.0302 103.772L59.3088 105.372Z",
    fill: "url(#paint147_linear)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1339 109.483L61.8744 111.152L78.7415 101.218L76.0011 99.5491L59.1339 109.483Z",
    fill: "url(#paint148_linear)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7335 99.2383L72.4736 100.907L75.1824 99.3068L72.4486 97.6379L69.7335 99.2383Z",
    fill: "url(#paint149_linear)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6705 98.2097L67.4106 99.8786L70.1257 98.2782L67.3856 96.6094L64.6705 98.2097Z",
    fill: "url(#paint150_linear)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9373 95.5772L64.6773 97.246L67.3924 95.6457L64.6523 93.9768L61.9373 95.5772Z",
    fill: "url(#paint151_linear)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2032 97.1936L75.9433 98.8563L78.6584 97.2621L75.9183 95.5933L73.2032 97.1936Z",
    fill: "url(#paint152_linear)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5005 99.2561L79.2406 100.925L82.8607 98.7953L80.1206 97.1265L76.5005 99.2561Z",
    fill: "url(#paint153_linear)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0261 96.5982L83.7662 98.2608L86.4813 96.6667L83.7412 94.9978L81.0261 96.5982Z",
    fill: "url(#paint154_linear)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4961 94.5476L87.2362 96.2165L89.9512 94.6161L87.2112 92.9473L84.4961 94.5476Z",
    fill: "url(#paint155_linear)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M87.973 92.5052L90.7131 94.174L93.4282 92.5737L90.6881 90.9048L87.973 92.5052Z",
    fill: "url(#paint156_linear)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1479 96.167L70.888 97.8359L73.6031 96.2355L70.8631 94.5667L68.1479 96.167Z",
    fill: "url(#paint157_linear)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3651 84.203L77.1052 85.8719L79.8203 84.2715L77.0802 82.6089L74.3651 84.203Z",
    fill: "url(#paint158_linear)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5894 85.3181L68.3294 86.987L71.0445 85.3866L68.3045 83.7178L65.5894 85.3181Z",
    fill: "url(#paint159_linear)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8843 86.26L73.6181 87.9289L76.3332 86.3285L73.5994 84.6597L70.8843 86.26Z",
    fill: "url(#paint160_linear)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7522 87.4417L78.4923 89.1106L83.2421 86.3146L80.5021 84.6458L75.7522 87.4417Z",
    fill: "url(#paint161_linear)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1166 87.3621L64.8566 89.031L67.5717 87.4306L64.8317 85.7617L62.1166 87.3621Z",
    fill: "url(#paint162_linear)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3942 88.3073L70.1342 89.9761L72.8493 88.3758L70.1093 86.7131L67.3942 88.3073Z",
    fill: "url(#paint163_linear)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3615 89.4405L75.1015 91.1093L77.8166 89.509L75.0766 87.8401L72.3615 89.4405Z",
    fill: "url(#paint164_linear)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M58.641 89.4102L61.3811 91.0728L64.0962 89.4787L61.3561 87.8098L58.641 89.4102Z",
    fill: "url(#paint165_linear)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3972 90.127L81.1377 91.7961L86.7871 88.4704L84.0467 86.8013L78.3972 90.127Z",
    fill: "url(#paint166_linear)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9092 90.365L66.643 92.0339L69.3581 90.4335L66.6243 88.7646L63.9092 90.365Z",
    fill: "url(#paint167_linear)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6049 91.0667L86.3449 92.7356L90.1336 90.5063L87.3935 88.8374L83.6049 91.0667Z",
    fill: "url(#paint168_linear)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8843 91.4856L71.6244 93.1545L74.3394 91.5541L71.5994 89.8853L68.8843 91.4856Z",
    fill: "url(#paint169_linear)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M55.17 91.4544L57.9101 93.1233L60.6252 91.5229L57.8851 89.854L55.17 91.4544Z",
    fill: "url(#paint170_linear)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0967 92.076L77.8367 93.7448L80.5518 92.1444L77.8118 90.4756L75.0967 92.076Z",
    fill: "url(#paint171_linear)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4211 92.4118L63.1612 94.0806L65.8763 92.4803L63.1362 90.8176L60.4211 92.4118Z",
    fill: "url(#paint172_linear)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1532 93.1026L82.8933 94.7714L85.6084 93.1711L82.8683 91.5022L80.1532 93.1026Z",
    fill: "url(#paint173_linear)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4152 93.5263L68.1552 95.1951L70.8703 93.601L68.1303 91.9321L65.4152 93.5263Z",
    fill: "url(#paint174_linear)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6205 94.1203L74.3605 95.7891L77.0756 94.195L74.3356 92.5261L71.6205 94.1203Z",
    fill: "url(#paint175_linear)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6825 95.1459L79.4226 96.8148L82.1314 95.2144L79.3976 93.5518L76.6825 95.1459Z",
    fill: "url(#paint176_linear)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3268 103.722L37.0668 105.391L39.7819 103.791L37.0419 102.122L34.3268 103.722Z",
    fill: "url(#paint177_linear)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1516 111.937L36.8917 113.606L39.6068 112.005L36.8667 110.336L34.1516 111.937Z",
    fill: "url(#paint178_linear)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1726 111.843L30.1499 113.661L34.6251 111.027L31.6416 109.208L27.1726 111.843Z",
    fill: "url(#paint179_linear)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9073 109.856L26.6474 111.525L29.3625 109.925L26.6224 108.256L23.9073 109.856Z",
    fill: "url(#paint180_linear)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9844 83.19L71.7244 84.8589L76.4743 82.0629L73.7342 80.394L68.9844 83.19Z",
    fill: "url(#paint181_linear)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7512 97.459L47.4913 99.1279L50.2001 97.5275L47.4601 95.8586L44.7512 97.459Z",
    fill: "url(#paint182_linear)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M56.936 94.3377L59.6761 96.0065L62.3912 94.4062L59.6511 92.7373L56.936 94.3377Z",
    fill: "url(#paint183_linear)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4464 96.3936L56.1865 98.0562L58.9016 96.4621L56.1615 94.7932L53.4464 96.3936Z",
    fill: "url(#paint184_linear)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4647 97.4901L61.2048 99.159L63.9199 97.5649L61.1798 95.896L58.4647 97.4901Z",
    fill: "url(#paint185_linear)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9879 99.5329L57.7342 101.202L60.4431 99.6076L57.703 97.9387L54.9879 99.5329Z",
    fill: "url(#paint186_linear)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1993 100.124L63.9394 101.793L66.6545 100.199L63.9144 98.5298L61.1993 100.124Z",
    fill: "url(#paint187_linear)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7229 102.173L60.4692 103.842L63.1781 102.241L60.438 100.572L57.7229 102.173Z",
    fill: "url(#paint188_linear)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7842 103.2L65.5242 104.869L68.2393 103.269L65.4993 101.6L62.7842 103.2Z",
    fill: "url(#paint189_linear)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9644 98.4412L52.7044 100.11L55.4195 98.5097L52.6795 96.8408L49.9644 98.4412Z",
    fill: "url(#paint190_linear)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2742 99.4994L44.0142 101.168L46.7293 99.5742L43.9893 97.9053L41.2742 99.4994Z",
    fill: "url(#paint191_linear)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4794 100.49L49.2194 102.159L51.9283 100.565L49.1945 98.8958L46.4794 100.49Z",
    fill: "url(#paint192_linear)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5188 101.578L54.2589 103.247L56.974 101.647L54.2339 99.978L51.5188 101.578Z",
    fill: "url(#paint193_linear)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9906 102.544L45.7307 104.213L48.4458 102.613L45.7057 100.944L42.9906 102.544Z",
    fill: "url(#paint194_linear)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0474 103.623L50.7874 105.292L53.4963 103.697L50.7562 102.029L48.0474 103.623Z",
    fill: "url(#paint195_linear)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5704 105.664L47.3105 107.333L50.0256 105.739L47.2855 104.07L44.5704 105.664Z",
    fill: "url(#paint196_linear)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2214 95.4153L50.9615 97.0842L53.6766 95.4838L50.9365 93.8149L48.2214 95.4153Z",
    fill: "url(#paint197_linear)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6932 93.3673L54.4395 95.0362L57.1484 93.4421L54.4083 91.7732L51.6932 93.3673Z",
    fill: "url(#paint198_linear)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2634 101.151L68.9973 102.82L71.7124 101.226L68.9723 99.5566L66.2634 101.151Z",
    fill: "url(#paint199_linear)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2518 104.216L56.9919 105.885L59.707 104.284L56.9669 102.615L54.2518 104.216Z",
    fill: "url(#paint200_linear)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7815 106.259L53.5216 107.928L56.2304 106.334L53.4903 104.665L50.7815 106.259Z",
    fill: "url(#paint201_linear)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3776 107.685L30.1176 109.354L32.8327 107.753L30.0927 106.084L27.3776 107.685Z",
    fill: "url(#paint202_linear)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M37.804 101.55L40.544 103.219L43.2591 101.619L40.5191 99.9497L37.804 101.55Z",
    fill: "url(#paint203_linear)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8081 111.901L57.5482 113.57L61.1621 111.44L58.422 109.771L54.8081 111.901Z",
    fill: "url(#paint204_linear)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3314 113.951L54.0715 115.62L56.7866 114.019L54.0465 112.351L51.3314 113.951Z",
    fill: "url(#paint205_linear)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9117 120.085L43.6518 121.754L46.3669 120.153L43.6268 118.484L40.9117 120.085Z",
    fill: "url(#paint206_linear)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5087 104.602L42.2487 106.264L44.9638 104.67L42.2238 103.001L39.5087 104.602Z",
    fill: "url(#paint207_linear)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8568 105.636L33.5969 107.305L36.312 105.711L33.5719 104.042L30.8568 105.636Z",
    fill: "url(#paint208_linear)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0238 106.65L38.7576 108.319L41.4727 106.718L38.7327 105.049L36.0238 106.65Z",
    fill: "url(#paint209_linear)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M41.094 107.716L43.8403 109.385L46.5554 107.785L43.8153 106.116L41.094 107.716Z",
    fill: "url(#paint210_linear)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5347 108.7L35.2747 110.368L37.9898 108.774L35.2498 107.105L32.5347 108.7Z",
    fill: "url(#paint211_linear)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6212 109.757L40.3613 111.426L43.0764 109.832L40.3363 108.163L37.6212 109.757Z",
    fill: "url(#paint212_linear)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8344 110.35L46.5744 112.019L49.2895 110.419L46.5494 108.756L43.8344 110.35Z",
    fill: "url(#paint213_linear)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8899 111.378L51.63 113.047L54.3451 111.447L51.605 109.778L48.8899 111.378Z",
    fill: "url(#paint214_linear)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3572 112.399L43.0972 114.068L45.8123 112.468L43.0723 110.799L40.3572 112.399Z",
    fill: "url(#paint215_linear)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4197 113.427L48.1597 115.089L50.8748 113.495L48.1348 111.826L45.4197 113.427Z",
    fill: "url(#paint216_linear)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8862 114.439L39.6263 116.108L42.3414 114.507L39.6013 112.839L36.8862 114.439Z",
    fill: "url(#paint217_linear)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8611 115.993L50.6011 117.662L53.3162 116.062L50.5762 114.393L47.8611 115.993Z",
    fill: "url(#paint218_linear)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6747 113.851L33.4151 115.52L36.9609 117.681L38.921 116.529L35.3753 114.368L36.1306 113.92L33.3902 112.25L32.6348 112.699L30.6747 113.851Z",
    fill: "url(#paint219_linear)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3829 118.035L47.123 119.704L49.8381 118.104L47.098 116.441L44.3829 118.035Z",
    fill: "url(#paint220_linear)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M37.566 118.048L40.3065 119.711L47.3979 115.538L44.6575 113.869L37.566 118.048Z",
    fill: "url(#paint221_linear)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3043 108.307L50.0444 109.976L52.7595 108.375L50.0194 106.707L47.3043 108.307Z",
    fill: "url(#paint222_linear)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3671 109.334L55.1009 111.003L57.816 109.403L55.0822 107.734L52.3671 109.334Z",
    fill: "url(#paint223_linear)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M55.837 107.292L58.5771 108.954L61.2922 107.36L58.5521 105.691L55.837 107.292Z",
    fill: "url(#paint224_linear)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3088 105.243L62.0489 106.912L64.764 105.312L62.0302 103.643L59.3088 105.243Z",
    fill: "url(#paint225_linear)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M59.134 109.354L61.8745 111.023L78.7417 101.089L76.0012 99.4202L59.134 109.354Z",
    fill: "url(#paint226_linear)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7335 99.1087L72.4736 100.778L75.1824 99.1772L72.4486 97.5083L69.7335 99.1087Z",
    fill: "url(#paint227_linear)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6708 98.0811L67.4109 99.75L70.1259 98.1496L67.3859 96.4807L64.6708 98.0811Z",
    fill: "url(#paint228_linear)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9375 95.4466L64.6776 97.1154L67.3927 95.5151L64.6526 93.8462L61.9375 95.4466Z",
    fill: "url(#paint229_linear)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2035 97.065L75.9436 98.7276L78.6586 97.1335L75.9186 95.4646L73.2035 97.065Z",
    fill: "url(#paint230_linear)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5005 99.1265L79.2406 100.795L82.8607 98.6657L80.1206 96.9968L76.5005 99.1265Z",
    fill: "url(#paint231_linear)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M81.026 96.4683L83.7661 98.1372L86.4812 96.5368L83.7411 94.8679L81.026 96.4683Z",
    fill: "url(#paint232_linear)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4961 94.4193L87.2362 96.0882L89.9512 94.4941L87.2112 92.8252L84.4961 94.4193Z",
    fill: "url(#paint233_linear)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9733 92.3763L90.7133 94.0451L93.4284 92.4447L90.6884 90.7759L87.9733 92.3763Z",
    fill: "url(#paint234_linear)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1482 96.0383L70.8883 97.7072L73.6034 96.1068L70.8633 94.438L68.1482 96.0383Z",
    fill: "url(#paint235_linear)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3654 84.0753L77.1054 85.7442L79.8205 84.1438L77.0804 82.4812L74.3654 84.0753Z",
    fill: "url(#paint236_linear)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5894 85.1895L68.3294 86.8583L71.0445 85.258L68.3045 83.5891L65.5894 85.1895Z",
    fill: "url(#paint237_linear)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8842 86.1309L73.618 87.7998L76.3331 86.1994L73.5992 84.5305L70.8842 86.1309Z",
    fill: "url(#paint238_linear)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7522 87.3143L78.4923 88.9832L83.2421 86.1872L80.5021 84.5183L75.7522 87.3143Z",
    fill: "url(#paint239_linear)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1167 87.2326L64.8568 88.9014L67.5719 87.3011L64.8318 85.6384L62.1167 87.2326Z",
    fill: "url(#paint240_linear)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3944 88.1786L70.1345 89.8475L72.8496 88.2533L70.1095 86.5845L67.3944 88.1786Z",
    fill: "url(#paint241_linear)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3617 89.3128L75.1018 90.9816L77.8169 89.3813L75.0768 87.7124L72.3617 89.3128Z",
    fill: "url(#paint242_linear)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6407 89.2825L61.3808 90.9514L64.0959 89.351L61.3558 87.6821L58.6407 89.2825Z",
    fill: "url(#paint243_linear)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3972 89.9984L81.1377 91.6675L86.7871 88.3417L84.0467 86.6726L78.3972 89.9984Z",
    fill: "url(#paint244_linear)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9094 90.2351L66.6432 91.904L69.3583 90.3036L66.6245 88.6348L63.9094 90.2351Z",
    fill: "url(#paint245_linear)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6052 90.9453L86.3453 92.6079L90.1339 90.3786L87.3939 88.7097L83.6052 90.9453Z",
    fill: "url(#paint246_linear)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8845 91.3555L71.6246 93.0244L74.3397 91.424L71.5996 89.7551L68.8845 91.3555Z",
    fill: "url(#paint247_linear)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1702 91.3233L57.9102 92.9921L60.6253 91.3918L57.8853 89.7229L55.1702 91.3233Z",
    fill: "url(#paint248_linear)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0969 91.9466L77.837 93.6154L80.5521 92.0151L77.812 90.3462L75.0969 91.9466Z",
    fill: "url(#paint249_linear)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4204 92.2831L63.1605 93.952L65.8756 92.3516L63.1355 90.689L60.4204 92.2831Z",
    fill: "url(#paint250_linear)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1534 92.9749L82.8935 94.6438L85.6086 93.0434L82.8685 91.3745L80.1534 92.9749Z",
    fill: "url(#paint251_linear)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4154 93.3986L68.1555 95.0675L70.8706 93.4733L68.1305 91.8044L65.4154 93.3986Z",
    fill: "url(#paint252_linear)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6204 93.9906L74.3604 95.6595L77.0755 94.0654L74.3355 92.3965L71.6204 93.9906Z",
    fill: "url(#paint253_linear)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6824 95.017L79.4224 96.6858L82.1313 95.0917L79.3975 93.4229L76.6824 95.017Z",
    fill: "url(#paint254_linear)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3268 103.594L37.0668 105.263L39.7819 103.662L37.0419 101.993L34.3268 103.594Z",
    fill: "url(#paint255_linear)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1516 111.807L36.8917 113.476L39.6068 111.876L36.8667 110.207L34.1516 111.807Z",
    fill: "url(#paint256_linear)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1729 111.714L30.1501 113.533L34.6253 110.899L31.6418 109.086L27.1729 111.714Z",
    fill: "url(#paint257_linear)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9076 109.727L26.6477 111.396L29.3628 109.796L26.6227 108.127L23.9076 109.727Z",
    fill: "url(#paint258_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 29.2601,
    y1: 81.8942,
    x2: 52.6504,
    y2: 108.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 18.8369,
    y1: 94.5163,
    x2: 27.5878,
    y2: 103.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 25.9571,
    y1: 98.4276,
    x2: 55.1,
    y2: 79.2923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D38F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4186,
    stopColor: "#795DFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7817,
    stopColor: "#8177FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8480FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 33.9187,
    y1: 88.0334,
    x2: 45.6085,
    y2: 80.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D38F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4186,
    stopColor: "#795DFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7817,
    stopColor: "#8177FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8480FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 31.0208,
    y1: 79.2728,
    x2: 38.3512,
    y2: 81.4251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 30.6613,
    y1: 73.575,
    x2: 40.7769,
    y2: 85.5962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: -34.847,
    y1: 45.4252,
    x2: 76.981,
    y2: 53.2635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00130208,
    stopColor: "#BF83FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0718,
    stopColor: "#B77BFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4779,
    stopColor: "#8E54FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7979,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9903,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 2.64342,
    y1: 0.62747,
    x2: 99.1334,
    y2: 50.4167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 2.61236,
    y1: 0.509553,
    x2: 95.3251,
    y2: 52.7518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 19.9851,
    y1: 109.963,
    x2: 40.3838,
    y2: 53.8366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 12.8732,
    y1: 15.5996,
    x2: 80.8493,
    y2: 55.5482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 14.8638,
    y1: 23.1104,
    x2: 71.8079,
    y2: 26.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F98905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7628"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 42.9595,
    y1: 63.85,
    x2: 43.5938,
    y2: 64.2231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 66.1931,
    y1: 39.6533,
    x2: 91.9824,
    y2: 30.6895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0311,
    stopColor: "#DDDBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5784,
    stopColor: "#ECECF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 66.4595,
    y1: 40.9421,
    x2: 90.8209,
    y2: 32.4745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0311,
    stopColor: "#DDDBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5784,
    stopColor: "#ECECF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 42.9351,
    y1: 53.7194,
    x2: 43.2889,
    y2: 54.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 42.9106,
    y1: 46.1073,
    x2: 43.2644,
    y2: 46.5279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 30.7104,
    y1: 57.8963,
    x2: 58.5497,
    y2: 48.5949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0311,
    stopColor: "#DDDBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5784,
    stopColor: "#ECECF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 28.281,
    y1: 57.7798,
    x2: 19.2304,
    y2: 59.1354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0311,
    stopColor: "#DDDBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5784,
    stopColor: "#ECECF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 29.8026,
    y1: 55.6586,
    x2: 46.2768,
    y2: 55.6586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0311,
    stopColor: "#DDDBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5784,
    stopColor: "#ECECF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 31.1018,
    y1: 59.0694,
    x2: 58.9411,
    y2: 49.7681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4216,
    stopColor: "#ECECF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9689,
    stopColor: "#DDDBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 46.1002,
    y1: 46.4937,
    x2: 75.9825,
    y2: 46.4937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4216,
    stopColor: "#ECECF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9689,
    stopColor: "#DDDBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 29.7397,
    y1: 117.561,
    x2: 85.2255,
    y2: 86.8067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D38F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4186,
    stopColor: "#795DFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7817,
    stopColor: "#8177FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8480FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 18.4554,
    y1: 109.405,
    x2: 38.9907,
    y2: 128.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 40.8677,
    y1: 93.0037,
    x2: 80.4109,
    y2: 137.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: 68.7148,
    y1: 80.4699,
    x2: 74.0271,
    y2: 86.5813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: 44.5551,
    y1: 95.968,
    x2: 48.4399,
    y2: 100.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x1: 47.8494,
    y1: 102.875,
    x2: 86.1547,
    y2: 75.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear",
    x1: 53.2501,
    y1: 94.8969,
    x2: 57.1343,
    y2: 99.3501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear",
    x1: 49.8467,
    y1: 105.698,
    x2: 88.1519,
    y2: 78.5856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear",
    x1: 49.6566,
    y1: 105.429,
    x2: 87.9616,
    y2: 78.3164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear",
    x1: 52.0021,
    y1: 108.743,
    x2: 90.3074,
    y2: 81.6301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear",
    x1: 51.8128,
    y1: 108.475,
    x2: 90.1179,
    y2: 81.3628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear",
    x1: 53.9798,
    y1: 111.538,
    x2: 92.2853,
    y2: 84.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear",
    x1: 47.4683,
    y1: 102.337,
    x2: 85.774,
    y2: 75.2242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear",
    x1: 45.0772,
    y1: 98.9609,
    x2: 83.3823,
    y2: 71.8485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear",
    x1: 47.2756,
    y1: 102.068,
    x2: 85.5807,
    y2: 74.9549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear",
    x1: 49.4674,
    y1: 105.161,
    x2: 87.7724,
    y2: 78.0488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear",
    x1: 47.0853,
    y1: 101.799,
    x2: 85.3904,
    y2: 74.6861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear",
    x1: 49.2777,
    y1: 104.895,
    x2: 87.5828,
    y2: 77.7821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear",
    x1: 49.0865,
    y1: 104.624,
    x2: 87.3917,
    y2: 77.5117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear",
    x1: 45.4575,
    y1: 99.4972,
    x2: 83.7622,
    y2: 72.3849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear",
    x1: 45.6489,
    y1: 99.7672,
    x2: 83.9539,
    y2: 72.6549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear",
    x1: 54.1724,
    y1: 111.806,
    x2: 92.4778,
    y2: 84.6932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear",
    x1: 51.6216,
    y1: 108.207,
    x2: 89.9271,
    y2: 81.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear",
    x1: 51.4317,
    y1: 107.939,
    x2: 89.7372,
    y2: 80.8258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear",
    x1: 44.3147,
    y1: 97.8882,
    x2: 82.6201,
    y2: 70.7755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear",
    x1: 44.8874,
    y1: 98.6932,
    x2: 83.193,
    y2: 71.5803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear",
    x1: 55.4606,
    y1: 113.631,
    x2: 93.7658,
    y2: 86.5181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear",
    x1: 55.2458,
    y1: 113.327,
    x2: 93.5511,
    y2: 86.2145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear",
    x1: 54.6736,
    y1: 112.523,
    x2: 92.9789,
    y2: 85.4103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear",
    x1: 46.8955,
    y1: 101.53,
    x2: 85.2005,
    y2: 74.4175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear",
    x1: 44.5073,
    y1: 98.1578,
    x2: 82.8126,
    y2: 71.0451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear",
    x1: 46.7033,
    y1: 101.26,
    x2: 85.0084,
    y2: 74.1479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear",
    x1: 48.8968,
    y1: 104.358,
    x2: 87.2025,
    y2: 77.2453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear",
    x1: 46.5124,
    y1: 100.991,
    x2: 84.8175,
    y2: 73.8783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear",
    x1: 48.705,
    y1: 104.09,
    x2: 87.0101,
    y2: 76.9771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear",
    x1: 51.0516,
    y1: 107.402,
    x2: 89.3566,
    y2: 80.2899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear",
    x1: 53.2196,
    y1: 110.466,
    x2: 91.5248,
    y2: 83.3529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear",
    x1: 50.8611,
    y1: 107.134,
    x2: 89.1669,
    y2: 80.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear",
    x1: 53.0298,
    y1: 110.197,
    x2: 91.335,
    y2: 83.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear",
    x1: 50.6713,
    y1: 106.865,
    x2: 88.9762,
    y2: 79.7525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear",
    x1: 55.0558,
    y1: 113.059,
    x2: 93.3608,
    y2: 85.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear",
    x1: 49.406,
    y1: 105.077,
    x2: 87.7162,
    y2: 77.9612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear",
    x1: 54.8643,
    y1: 112.791,
    x2: 93.1693,
    y2: 85.6783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear",
    x1: 52.7206,
    y1: 109.761,
    x2: 91.0314,
    y2: 82.6441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear",
    x1: 51.2412,
    y1: 107.67,
    x2: 89.5461,
    y2: 80.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear",
    x1: 53.4102,
    y1: 110.734,
    x2: 91.7152,
    y2: 83.6214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear",
    x1: 53.5997,
    y1: 111.002,
    x2: 91.9048,
    y2: 83.8895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear",
    x1: 53.7911,
    y1: 111.269,
    x2: 92.0966,
    y2: 84.1565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear",
    x1: 56.0595,
    y1: 114.477,
    x2: 94.37,
    y2: 87.3606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear",
    x1: 54.3622,
    y1: 112.074,
    x2: 92.6673,
    y2: 84.9614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear",
    x1: 52.1932,
    y1: 109.01,
    x2: 90.4984,
    y2: 81.8968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear",
    x1: 50.0392,
    y1: 105.966,
    x2: 88.3442,
    y2: 78.8534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear",
    x1: 54.5517,
    y1: 112.342,
    x2: 92.8572,
    y2: 85.2293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear",
    x1: 56.6495,
    y1: 115.304,
    x2: 94.955,
    y2: 88.1916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear",
    x1: 56.8725,
    y1: 115.619,
    x2: 95.1781,
    y2: 88.5063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear",
    x1: 57.0624,
    y1: 115.886,
    x2: 95.3676,
    y2: 88.7735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear",
    x1: 57.2529,
    y1: 116.155,
    x2: 95.5583,
    y2: 89.0421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear",
    x1: 52.384,
    y1: 109.279,
    x2: 90.689,
    y2: 82.1662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear",
    x1: 48.8053,
    y1: 104.221,
    x2: 87.1105,
    y2: 77.1085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear",
    x1: 46.4111,
    y1: 100.838,
    x2: 84.7161,
    y2: 73.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear",
    x1: 48.6163,
    y1: 103.951,
    x2: 86.9217,
    y2: 76.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear",
    x1: 50.8523,
    y1: 107.112,
    x2: 89.1575,
    y2: 79.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear",
    x1: 46.2185,
    y1: 100.571,
    x2: 84.5241,
    y2: 73.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear",
    x1: 48.4248,
    y1: 103.683,
    x2: 86.7303,
    y2: 76.5697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear",
    x1: 50.6096,
    y1: 106.771,
    x2: 88.915,
    y2: 79.6588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear",
    x1: 46.0294,
    y1: 100.303,
    x2: 84.3344,
    y2: 73.1902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear",
    x1: 53.0216,
    y1: 110.188,
    x2: 91.3322,
    y2: 83.0711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear",
    x1: 48.2322,
    y1: 103.414,
    x2: 86.5375,
    y2: 76.3009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear",
    x1: 55.1532,
    y1: 113.187,
    x2: 93.4583,
    y2: 86.0747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear",
    x1: 50.4191,
    y1: 106.503,
    x2: 88.7244,
    y2: 79.3904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear",
    x1: 45.8393,
    y1: 100.033,
    x2: 84.1443,
    y2: 72.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear",
    x1: 52.7656,
    y1: 109.815,
    x2: 91.0706,
    y2: 82.7031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear",
    x1: 48.0417,
    y1: 103.144,
    x2: 86.3467,
    y2: 76.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear",
    x1: 54.9346,
    y1: 112.879,
    x2: 93.24,
    y2: 85.7667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear",
    x1: 50.2303,
    y1: 106.236,
    x2: 88.5357,
    y2: 79.1229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear",
    x1: 52.5758,
    y1: 109.549,
    x2: 90.8808,
    y2: 82.4366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear",
    x1: 54.744,
    y1: 112.61,
    x2: 93.0492,
    y2: 85.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear",
    x1: 44.6968,
    y1: 98.4255,
    x2: 83.0016,
    y2: 71.3132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear",
    x1: 48.5151,
    y1: 103.822,
    x2: 86.8203,
    y2: 76.7092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear",
    x1: 46.2733,
    y1: 100.654,
    x2: 84.5785,
    y2: 73.5415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear",
    x1: 44.125,
    y1: 97.6215,
    x2: 82.4301,
    y2: 70.5091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3345,
    stopColor: "#3C21A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#552BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#6531EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear",
    x1: 7.42823,
    y1: 116.368,
    x2: 81.1935,
    y2: 78.2206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear",
    x1: 8.18807,
    y1: 117.846,
    x2: 81.9534,
    y2: 79.6984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear",
    x1: 9.47697,
    y1: 120.333,
    x2: 83.2418,
    y2: 82.1858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear",
    x1: 9.58127,
    y1: 120.537,
    x2: 83.3464,
    y2: 82.3903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear",
    x1: 11.0852,
    y1: 123.447,
    x2: 84.8502,
    y2: 85.2999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear",
    x1: 11.1899,
    y1: 123.648,
    x2: 84.955,
    y2: 85.5012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear",
    x1: 12.7374,
    y1: 126.639,
    x2: 86.5023,
    y2: 88.4925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear",
    x1: 12.8421,
    y1: 126.842,
    x2: 86.6077,
    y2: 88.6946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear",
    x1: 14.3243,
    y1: 129.711,
    x2: 88.0901,
    y2: 91.5637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear",
    x1: 9.68675,
    y1: 120.742,
    x2: 83.4527,
    y2: 82.5948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear",
    x1: 8.29277,
    y1: 118.047,
    x2: 82.0575,
    y2: 79.9002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear",
    x1: 9.79038,
    y1: 120.946,
    x2: 83.5553,
    y2: 82.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear",
    x1: 11.2957,
    y1: 123.852,
    x2: 85.0606,
    y2: 85.7047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear",
    x1: 9.89604,
    y1: 121.149,
    x2: 83.661,
    y2: 83.0018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear",
    x1: 11.4009,
    y1: 124.057,
    x2: 85.1655,
    y2: 85.9101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear",
    x1: 11.5046,
    y1: 124.258,
    x2: 85.2701,
    y2: 86.1112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear",
    x1: 8.08335,
    y1: 117.642,
    x2: 81.8479,
    y2: 79.4957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear",
    x1: 7.97982,
    y1: 117.44,
    x2: 81.7447,
    y2: 79.2933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear",
    x1: 14.2215,
    y1: 129.507,
    x2: 87.9873,
    y2: 91.3597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear",
    x1: 12.9463,
    y1: 127.045,
    x2: 86.7115,
    y2: 88.8985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear",
    x1: 13.051,
    y1: 127.249,
    x2: 86.8164,
    y2: 89.1019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear",
    x1: 8.70974,
    y1: 118.861,
    x2: 82.475,
    y2: 80.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear",
    x1: 8.39727,
    y1: 118.251,
    x2: 82.1628,
    y2: 80.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear",
    x1: 16.1885,
    y1: 133.313,
    x2: 89.9536,
    y2: 95.1657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear",
    x1: 16.3069,
    y1: 133.542,
    x2: 90.0722,
    y2: 95.3944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear",
    x1: 16.6195,
    y1: 134.153,
    x2: 90.3844,
    y2: 96.0064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear",
    x1: 10.002,
    y1: 121.353,
    x2: 83.7669,
    y2: 83.2066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear",
    x1: 8.60691,
    y1: 118.659,
    x2: 82.3725,
    y2: 80.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear",
    x1: 10.1051,
    y1: 121.558,
    x2: 83.8702,
    y2: 83.4107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear",
    x1: 11.6092,
    y1: 124.462,
    x2: 85.3747,
    y2: 86.3145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear",
    x1: 10.2107,
    y1: 121.761,
    x2: 83.9756,
    y2: 83.6136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear",
    x1: 11.7119,
    y1: 124.664,
    x2: 85.4764,
    y2: 86.5173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear",
    x1: 13.2608,
    y1: 127.655,
    x2: 87.0256,
    y2: 89.5083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear",
    x1: 14.7436,
    y1: 130.523,
    x2: 88.5087,
    y2: 92.3759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear",
    x1: 13.365,
    y1: 127.859,
    x2: 87.1304,
    y2: 89.7117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear",
    x1: 14.8489,
    y1: 130.726,
    x2: 88.6139,
    y2: 92.5793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear",
    x1: 13.4695,
    y1: 128.06,
    x2: 87.2343,
    y2: 89.9132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear",
    x1: 16.4119,
    y1: 133.748,
    x2: 90.177,
    y2: 95.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear",
    x1: 12.733,
    y1: 126.647,
    x2: 86.5079,
    y2: 88.4951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear",
    x1: 16.5152,
    y1: 133.95,
    x2: 90.2801,
    y2: 95.8031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear",
    x1: 15.0147,
    y1: 131.061,
    x2: 88.7904,
    y2: 92.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear",
    x1: 13.156,
    y1: 127.452,
    x2: 86.921,
    y2: 89.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear",
    x1: 14.6393,
    y1: 130.32,
    x2: 88.4045,
    y2: 92.1728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear",
    x1: 14.5343,
    y1: 130.117,
    x2: 88.2992,
    y2: 91.9698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear",
    x1: 14.4308,
    y1: 129.913,
    x2: 88.1957,
    y2: 91.766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear",
    x1: 15.8519,
    y1: 132.677,
    x2: 89.6274,
    y2: 94.5249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear",
    x1: 14.117,
    y1: 129.304,
    x2: 87.8821,
    y2: 91.1572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear",
    x1: 12.6326,
    y1: 126.436,
    x2: 86.3984,
    y2: 88.2883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear",
    x1: 10.9827,
    y1: 123.244,
    x2: 84.7476,
    y2: 85.0969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear",
    x1: 14.011,
    y1: 129.1,
    x2: 87.7768,
    y2: 90.9526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear",
    x1: 15.5354,
    y1: 132.045,
    x2: 89.3014,
    y2: 93.8973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear",
    x1: 15.413,
    y1: 131.808,
    x2: 89.1788,
    y2: 93.6607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear",
    x1: 15.3075,
    y1: 131.603,
    x2: 89.0732,
    y2: 93.4561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear",
    x1: 15.2033,
    y1: 131.4,
    x2: 88.9684,
    y2: 93.2532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear",
    x1: 12.5294,
    y1: 126.232,
    x2: 86.2945,
    y2: 88.0855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear",
    x1: 8.95283,
    y1: 119.313,
    x2: 82.7176,
    y2: 81.1666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear",
    x1: 7.56263,
    y1: 116.626,
    x2: 81.3274,
    y2: 78.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear",
    x1: 9.05953,
    y1: 119.519,
    x2: 82.8248,
    y2: 81.3723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear",
    x1: 10.537,
    y1: 122.374,
    x2: 84.3017,
    y2: 84.2277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear",
    x1: 7.66404,
    y1: 116.831,
    x2: 81.43,
    y2: 78.6834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear",
    x1: 9.16332,
    y1: 119.722,
    x2: 82.929,
    y2: 81.5743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear",
    x1: 10.6682,
    y1: 122.632,
    x2: 84.4334,
    y2: 84.4848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear",
    x1: 7.77052,
    y1: 117.033,
    x2: 81.5356,
    y2: 78.8854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear",
    x1: 12.1662,
    y1: 125.553,
    x2: 85.9414,
    y2: 87.4007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear",
    x1: 9.26745,
    y1: 119.928,
    x2: 83.0324,
    y2: 81.7811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear",
    x1: 13.6849,
    y1: 128.46,
    x2: 87.4494,
    y2: 90.3133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear",
    x1: 10.7728,
    y1: 122.838,
    x2: 84.5376,
    y2: 84.6907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear",
    x1: 7.87513,
    y1: 117.237,
    x2: 81.6401,
    y2: 79.0904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear",
    x1: 12.3213,
    y1: 125.827,
    x2: 86.0861,
    y2: 87.6797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear",
    x1: 9.37366,
    y1: 120.13,
    x2: 83.1386,
    y2: 81.9827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear",
    x1: 13.8048,
    y1: 128.693,
    x2: 87.5697,
    y2: 90.5463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear",
    x1: 10.8786,
    y1: 123.039,
    x2: 84.644,
    y2: 84.8919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear",
    x1: 12.4266,
    y1: 126.031,
    x2: 86.1916,
    y2: 87.8844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear",
    x1: 13.9095,
    y1: 128.897,
    x2: 87.6748,
    y2: 90.7505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear",
    x1: 8.50235,
    y1: 118.455,
    x2: 82.2668,
    y2: 80.3086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear",
    x1: 11.8178,
    y1: 124.868,
    x2: 85.5828,
    y2: 86.7216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear",
    x1: 10.3422,
    y1: 122.016,
    x2: 84.1075,
    y2: 83.8688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear",
    x1: 8.81483,
    y1: 119.064,
    x2: 82.5797,
    y2: 80.9172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#743CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8D53FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#B57AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear",
    x1: 7.42847,
    y1: 116.239,
    x2: 81.1937,
    y2: 78.0924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear",
    x1: 8.18825,
    y1: 117.717,
    x2: 81.9535,
    y2: 79.5701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear",
    x1: 9.47697,
    y1: 120.205,
    x2: 83.2418,
    y2: 82.0576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear",
    x1: 9.58152,
    y1: 120.409,
    x2: 83.3463,
    y2: 82.2624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear",
    x1: 11.0852,
    y1: 123.318,
    x2: 84.8501,
    y2: 85.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear",
    x1: 11.1899,
    y1: 123.521,
    x2: 84.9548,
    y2: 85.3738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear",
    x1: 12.7374,
    y1: 126.511,
    x2: 86.5024,
    y2: 88.3639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear",
    x1: 12.8421,
    y1: 126.714,
    x2: 86.6076,
    y2: 88.5664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear",
    x1: 14.3246,
    y1: 129.581,
    x2: 88.0898,
    y2: 91.4344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear",
    x1: 9.68731,
    y1: 120.612,
    x2: 83.4529,
    y2: 82.4649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear",
    x1: 8.29283,
    y1: 117.918,
    x2: 82.0581,
    y2: 79.7713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear",
    x1: 9.79044,
    y1: 120.816,
    x2: 83.5559,
    y2: 82.6687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear",
    x1: 11.2962,
    y1: 123.721,
    x2: 85.0612,
    y2: 85.5735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear",
    x1: 9.89629,
    y1: 121.019,
    x2: 83.6612,
    y2: 82.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear",
    x1: 11.4,
    y1: 123.925,
    x2: 85.1647,
    y2: 85.7785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear",
    x1: 11.5044,
    y1: 124.128,
    x2: 85.2699,
    y2: 85.9803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear",
    x1: 8.08359,
    y1: 117.513,
    x2: 81.8481,
    y2: 79.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear",
    x1: 7.98,
    y1: 117.311,
    x2: 81.7449,
    y2: 79.1642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear",
    x1: 14.2217,
    y1: 129.378,
    x2: 87.9875,
    y2: 91.2305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear",
    x1: 12.9465,
    y1: 126.917,
    x2: 86.7118,
    y2: 88.7705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear",
    x1: 13.0511,
    y1: 127.121,
    x2: 86.8172,
    y2: 88.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear",
    x1: 8.70974,
    y1: 118.733,
    x2: 82.475,
    y2: 80.5858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear",
    x1: 8.39733,
    y1: 118.123,
    x2: 82.1633,
    y2: 79.9757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear",
    x1: 16.1885,
    y1: 133.185,
    x2: 89.9535,
    y2: 95.0382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear",
    x1: 16.3067,
    y1: 133.416,
    x2: 90.0724,
    y2: 95.2691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear",
    x1: 16.6195,
    y1: 134.025,
    x2: 90.3846,
    y2: 95.8781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear",
    x1: 10.0027,
    y1: 121.224,
    x2: 83.7671,
    y2: 83.0779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear",
    x1: 8.60753,
    y1: 118.53,
    x2: 82.3725,
    y2: 80.3831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear",
    x1: 10.1057,
    y1: 121.428,
    x2: 83.8709,
    y2: 83.2806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear",
    x1: 11.6093,
    y1: 124.334,
    x2: 85.3752,
    y2: 86.1864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear",
    x1: 10.211,
    y1: 121.632,
    x2: 83.9758,
    y2: 83.4853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear",
    x1: 11.7121,
    y1: 124.535,
    x2: 85.4771,
    y2: 86.3884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear",
    x1: 13.2612,
    y1: 127.527,
    x2: 87.0261,
    y2: 89.3799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear",
    x1: 14.7439,
    y1: 130.395,
    x2: 88.509,
    y2: 92.2479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear",
    x1: 13.3655,
    y1: 127.73,
    x2: 87.1309,
    y2: 89.5829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear",
    x1: 14.8492,
    y1: 130.597,
    x2: 88.6143,
    y2: 92.4506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear",
    x1: 13.4699,
    y1: 127.93,
    x2: 87.2348,
    y2: 89.7831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear",
    x1: 16.412,
    y1: 133.619,
    x2: 90.1773,
    y2: 95.4717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear",
    x1: 12.7333,
    y1: 126.518,
    x2: 86.5085,
    y2: 88.3658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear",
    x1: 16.5153,
    y1: 133.822,
    x2: 90.2807,
    y2: 95.6746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear",
    x1: 15.0152,
    y1: 130.931,
    x2: 88.7908,
    y2: 92.7783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear",
    x1: 13.1561,
    y1: 127.323,
    x2: 86.921,
    y2: 89.1759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear",
    x1: 14.6395,
    y1: 130.191,
    x2: 88.4048,
    y2: 92.0436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear",
    x1: 14.5343,
    y1: 129.988,
    x2: 88.2996,
    y2: 91.8405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear",
    x1: 14.4306,
    y1: 129.785,
    x2: 88.1958,
    y2: 91.6376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear",
    x1: 15.8521,
    y1: 132.549,
    x2: 89.6275,
    y2: 94.3964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear",
    x1: 14.117,
    y1: 129.175,
    x2: 87.8821,
    y2: 91.0281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear",
    x1: 12.6332,
    y1: 126.307,
    x2: 86.3986,
    y2: 88.1602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear",
    x1: 10.9829,
    y1: 123.114,
    x2: 84.7478,
    y2: 84.9668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear",
    x1: 14.0112,
    y1: 128.971,
    x2: 87.7769,
    y2: 90.8241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear",
    x1: 15.5357,
    y1: 131.916,
    x2: 89.3014,
    y2: 93.7681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear",
    x1: 15.4129,
    y1: 131.679,
    x2: 89.1788,
    y2: 93.5314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear",
    x1: 15.3079,
    y1: 131.475,
    x2: 89.0732,
    y2: 93.3285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear",
    x1: 15.204,
    y1: 131.272,
    x2: 88.9686,
    y2: 93.1248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear",
    x1: 12.5297,
    y1: 126.104,
    x2: 86.2945,
    y2: 87.9568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear",
    x1: 8.95307,
    y1: 119.186,
    x2: 82.7179,
    y2: 81.0395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint237_linear",
    x1: 7.56263,
    y1: 116.497,
    x2: 81.3273,
    y2: 78.3506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear",
    x1: 9.05941,
    y1: 119.391,
    x2: 82.8248,
    y2: 81.2439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint239_linear",
    x1: 10.537,
    y1: 122.247,
    x2: 84.3016,
    y2: 84.1005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint240_linear",
    x1: 7.66417,
    y1: 116.701,
    x2: 81.4299,
    y2: 78.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint241_linear",
    x1: 9.16394,
    y1: 119.594,
    x2: 82.9293,
    y2: 81.4464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint242_linear",
    x1: 10.6681,
    y1: 122.505,
    x2: 84.4339,
    y2: 84.3578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint243_linear",
    x1: 7.77027,
    y1: 116.905,
    x2: 81.5354,
    y2: 78.7583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint244_linear",
    x1: 12.1664,
    y1: 125.425,
    x2: 85.9414,
    y2: 87.2725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint245_linear",
    x1: 9.26738,
    y1: 119.799,
    x2: 83.0328,
    y2: 81.6517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint246_linear",
    x1: 13.6856,
    y1: 128.333,
    x2: 87.45,
    y2: 90.1863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint247_linear",
    x1: 10.7734,
    y1: 122.708,
    x2: 84.5377,
    y2: 84.5611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint248_linear",
    x1: 7.87531,
    y1: 117.106,
    x2: 81.6401,
    y2: 78.9596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint249_linear",
    x1: 12.3215,
    y1: 125.698,
    x2: 86.0865,
    y2: 87.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint250_linear",
    x1: 9.37261,
    y1: 120.002,
    x2: 83.138,
    y2: 81.8545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint251_linear",
    x1: 13.8047,
    y1: 128.566,
    x2: 87.5702,
    y2: 90.4193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint252_linear",
    x1: 10.8789,
    y1: 122.912,
    x2: 84.6442,
    y2: 84.7647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint253_linear",
    x1: 12.4261,
    y1: 125.902,
    x2: 86.1914,
    y2: 87.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint254_linear",
    x1: 13.9093,
    y1: 128.769,
    x2: 87.6743,
    y2: 90.6213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint255_linear",
    x1: 8.50241,
    y1: 118.327,
    x2: 82.2668,
    y2: 80.1805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint256_linear",
    x1: 11.8178,
    y1: 124.739,
    x2: 85.5827,
    y2: 86.5923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint257_linear",
    x1: 10.3424,
    y1: 121.888,
    x2: 84.1078,
    y2: 83.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint258_linear",
    x1: 8.81507,
    y1: 118.936,
    x2: 82.58,
    y2: 80.7888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00971554,
    stopColor: "#6B33F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#854CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#9F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#B175FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#BC80FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BF83FB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature4200709F);
export default __webpack_public_path__ + "static/media/feature-4.200709f.200709faa863294ca2169965d79609af.svg";
export { ForwardRef as ReactComponent };